
// Global Constants, Action Names, Validators and API for backend messaging
// TODO: add DataEnum, replace custom types with DataMap

export const CLIENT_VERSION = '1792833292813';

export const TRIAL_DURATION_DAYS = 50;
export const TRIAL_PROJECT_LIMIT = 3;
export const TRIAL_SCHEDULE_LIMIT = 50;
export const TRIAL_ADDITIONAL_USER_LIMIT = 5;
export const STANDARD_SUBSCRIPTION_PRICE_MONTHLY = 15;
export const STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY = 5;
export const STANDARD_SUBSCRIPTION_EXPIRED_GRACE_PERIOD_DAYS = 2;

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REQUEST_LOGIN_CODE = 'REQUEST_LOGIN_CODE';
export const REQUEST_TRIAL_SIGNUP_CODE = 'REQUEST_TRIAL_SIGNUP_CODE';
export const REQUEST_STANDARD_SIGNUP_CODE = 'REQUEST_STANDARD_SIGNUP_CODE';
export const CHECK_LOGIN_CODE = 'CHECK_LOGIN_CODE';
export const CHECK_TRIAL_SIGNUP_CODE = 'CHECK_TRIAL_SIGNUP_CODE';
export const CHECK_STANDARD_SIGNUP_CODE = 'CHECK_STANDARD_SIGNUP_CODE';

export const INVITE_LINK_EXPIRE_TIME_DAYS = 30;

export const GET_SUBSCRIPTION_INVITE_LINK_DETAILS = 'GET_SUBSCRIPTION_INVITE_LINK_DETAILS';
export const REDEEM_SUBSCRIPTION_INVITE_LINK = 'REDEEM_SUBSCRIPTION_INVITE_LINK';
export const REQUEST_FRESH_SUBSCRIPTION_INVITE_LINK = 'REQUEST_FRESH_SUBSCRIPTION_INVITE_LINK';

export const ADD_USER = 'ADD_USER';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';

export const SET_NAME = 'SET_NAME';
export const SET_DARK_MODE = 'SET_DARK_MODE';
export const SET_STARTUP_WELCOME_ENABLED = 'SET_STARTUP_WELCOME_ENABLED';
export const SET_PREFERS_PROJECTS_LIST_VIEW = 'SET_PREFERS_PROJECTS_LIST_VIEW';
export const SET_PROFILE_DIALOGUE_SHOWING = 'SET_PROFILE_DIALOGUE_SHOWING';

export const ADD_PROJECT = 'ADD_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const SET_PROJECTS = 'SET_PROJECTS';
export const GET_PROJECTS = 'GET_PROJECTS';
export const ADD_PROJECT_MEMBER = 'ADD_PROJECT_MEMBER';
export const ADD_SUBSCRIPTION_ADMIN = 'ADD_SUBSCRIPTION_ADMIN';
export const REMOVE_SUBSCRIPTION_ADMIN = 'REMOVE_SUBSCRIPTION_ADMIN';
export const REMOVE_PENDING_SUBSCRIPTION_ADMIN = 'REMOVE_PENDING_SUBSCRIPTION_ADMIN';
export const REMOVE_PROJECT_MEMBER = 'REMOVE_PROJECT_MEMBER';
export const REMOVE_PENDING_PROJECT_MEMBER = 'REMOVE_PENDING_PROJECT_MEMBER';
export const CHANGE_PROJECT_MEMBER_ROLE = 'CHANGE_PROJECT_MEMBER_ROLE';
export const CHANGE_PENDING_PROJECT_MEMBER_ROLE = 'CHANGE_PENDING_PROJECT_MEMBER_ROLE';
export const SET_DELETE_PROJECT_DIALOGUE_ID = 'SET_DELETE_PROJECT_DIALOGUE_ID';
export const SET_EDIT_PROJECT_DIALOGUE_ID = 'SET_EDIT_PROJECT_DIALOGUE_ID';
export const SET_NEW_PROJECT_DIALOGUE_SHOWING = 'SET_NEW_PROJECT_DIALOGUE_SHOWING';
export const SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID = 'SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID ';
export const SET_LAST_VIEWED_PROJECT = 'SET_LAST_VIEWED_PROJECT';
export const GET_SUBSCRIPTION_INVITES = 'GET_SUBSCRIPTION_INVITES';
export const ACCEPT_SUBSCRIPTION_INVITE = 'ACCEPT_SUBSCRIPTION_INVITE';
export const REJECT_SUBSCRIPTION_INVITE = 'REJECT_SUBSCRIPTION_INVITE';
export const SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING = 'SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING';

export const ADD_SCHEDULE = 'ADD_SCHEDULE';
export const SET_SCHEDULE = 'SET_SCHEDULE';
export const EDIT_SCHEDULE = 'EDIT_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const PUBLISH_SCHEDULE = 'PUBLISH_SCHEDULE';
export const UNPUBLISH_SCHEDULE = 'UNPUBLISH_SCHEDULE';
export const SET_PUBLISH_SCHEDULE_DIALOGUE_ID = 'SET_PUBLISH_SCHEDULE_DIALOGUE_ID';
export const SET_UNPUBLISH_SCHEDULE_DIALOGUE_ID = 'SET_UNPUBLISH_SCHEDULE_DIALOGUE_ID';
export const SET_NEW_SCHEDULE_DIALOGUE_ID = 'SET_NEW_SCHEDULE_DIALOGUE_ID';
export const FETCH_SCHEDULE_PDF = 'FETCH_SCHEDULE_PDF';
export const SET_SHARE_LINK_DIALOGUE_SHOWING = 'SET_SHARE_LINK_DIALOGUE_SHOWING';
export const SET_EDIT_SCHEDULE_DIALOGUE_SHOWING = 'SET_EDIT_SCHEDULE_DIALOGUE_SHOWING';
export const GET_CONTACT_SHARED_SCHEDULE_STATS = 'GET_CONTACT_SHARED_SCHEDULE_STATS';
export const SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING = 'SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING';
export const SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING = 'SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING';

export const GET_SCHEDULE = 'GET_SCHEDULE';
export const GET_PROJECT_SCHEDULES = 'GET_PROJECT_SCHEDULES';
export const SET_PROJECT_SCHEDULES = 'SET_PROJECT_SCHEDULES';
export const SET_DELETE_SCHEDULE_DIALOGUE_ID = 'SET_DELETE_SCHEDULE_DIALOGUE_ID';

export const SET_SCHEDULE_MESSAGES_DIALOGUE_ID = 'SET_SCHEDULE_MESSAGES_DIALOGUE_ID';
export const ADD_SCHEDULE_MESSAGE_THREAD = 'ADD_SCHEDULE_MESSAGE_THREAD';
export const GET_SCHEDULE_MESSAGE_THREADS = 'GET_SCHEDULE_MESSAGE_THREADS';
export const ADD_SCHEDULE_MESSAGE = 'ADD_SCHEDULE_MESSAGE';
export const GET_SCHEDULE_MESSAGES = 'GET_SCHEDULE_MESSAGES';

export const ENTER_SCHEDULE_MESSAGE_THREAD = 'ENTER_SCHEDULE_MESSAGE_THREAD';
export const LEAVE_SCHEDULE_MESSAGE_THREAD = 'LEAVE_SCHEDULE_MESSAGE_THREAD';

export const SET_UNREAD_MESSAGES_DIALOGUE_OPEN = 'SET_UNREAD_MESSAGES_DIALOGUE_OPEN';
export const ADD_UNREAD_SCHEDULE_MESSAGE_THREAD = 'ADD_UNREAD_SCHEDULE_MESSAGE_THREAD';
export const ADD_ALL_UNREAD_SCHEDULE_MESSAGE_THREADS = 'ADD_ALL_UNREAD_SCHEDULE_MESSAGE_THREADS';

export const ADD_ALL_SUBSCRIPTIONS = 'ADD_ALL_SUBSCRIPTIONS';
export const CREATE_TRIAL_SUBSCRIPTION = 'CREATE_TRIAL_SUBSCRIPTION';
export const CREATE_STANDARD_SUBSCRIPTION_CHECKOUT = 'CREATE_STANDARD_SUBSCRIPTION_CHECKOUT';
export const CANCEL_PENDING_STANDARD_SUBSCRIPTION = 'CANCEL_PENDING_STANDARD_SUBSCRIPTION';
export const CREATE_STRIPE_PORTAL_SESSION = 'CREATE_STRIPE_PORTAL_SESSION';
export const UPDATE_STRIPE_SUBSCRIPTION_QUANTITY = 'UPDATE_STRIPE_SUBSCRIPTION_QUANTITY';
export const SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN = 'SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN';
export const SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN = 'SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN';
export const SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN = 'SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN';

export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const ADD_TEMPORARY_ACTIVITY = 'ADD_TEMPORARY_ACTIVITY';
export const REPLACE_TEMPORARY_ACTIVITY_ID = 'REPLACE_TEMPORARY_ACTIVITY_ID';
export const SET_ACTIVITY = 'SET_ACTIVITY';
export const EDIT_ACTIVITY = 'EDIT_ACTIVITY';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';
export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export const GET_SCHEDULE_ACTIVITIES = 'GET_SCHEDULE_ACTIVITIES';
export const SET_SCHEDULE_ACTIVITIES = 'SET_SCHEDULE_ACTIVITIES';
export const GET_SHARE_SCHEDULE_LINK = 'GET_SHARE_SCHEDULE_LINK';

export const GENERATE_SHARE_SCHEDULE_LINK = 'GENERATE_SHARE_SCHEDULE_LINK';
export const REDEEM_SHARE_SCHEDULE_LINK = 'REDEEM_SHARE_SCHEDULE_LINK';
export const SET_USING_SHARE_SCHEDULE_LINK = 'SET_USING_SHARE_SCHEDULE_LINK';
export const REDEEM_SHARE_SCHEDULE_LINK_INVITE = 'REDEEM_SHARE_SCHEDULE_LINK_INVITE';
export const CONFIRM_SHARE_SCHEDULE_DATES = 'CONFIRM_SHARE_SCHEDULE_DATES';
export const SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN = 'SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN';
export const SET_SHARE_SCHEDULE_CONFIRMED = 'SET_SHARE_SCHEDULE_CONFIRMED';
export const SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN = 'SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN';
export const SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN = 'SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN';

export const SET_PATH = 'SET_PATH';
export const SET_LOADING = 'SET_LOADING';
export const SET_ALERT = 'SET_ALERT';

export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING';
export const FETCH_DATA_COMPLETE = 'FETCH_DATA_COMPLETE';
export const FETCH_DATA_FAIL = 'FETCH_DATA_FAIL';

export const WEBSOCKET_CONNECTING = 'WEBSOCKET_CONNECTING';
export const WEBSOCKET_CONNECTED = 'WEBSOCKET_CONNECTED';
export const WEBSOCKET_AUTHORIZED = 'WEBSOCKET_AUTHORIZED';
export const WEBSOCKET_DISCONNECTED = 'WEBSOCKET_DISCONNECTED';

export const GET_PROJECT_CONTRACTORS = 'GET_PROJECT_CONTRACTORS';
export const SET_PROJECT_CONTRACTORS = 'SET_PROJECT_CONTRACTORS';
export const SET_EDIT_CONTRACTORS_DIALOGUE_ID = 'SET_EDIT_CONTRACTORS_DIALOGUE_ID';

export const MAX_SCHEDULE_CONTACTS_COUNT = 1000;
export const GET_PROJECT_SCHEDULE_CONTACTS = 'GET_PROJECT_SCHEDULE_CONTACTS';
export const ADD_PROJECT_SCHEDULE_CONTACTS = 'ADD_PROJECT_SCHEDULE_CONTACTS';
export const DELETE_PROJECT_SCHEDULE_CONTACT = 'DELETE_PROJECT_SCHEDULE_CONTACT';
export const SET_DELETE_CONTACT_DIALOGUE_OPEN = 'SET_DELETE_CONTACT_DIALOGUE_OPEN';
export const SET_PROJECT_CONTACTS_DIALOGUE_ID = 'SET_PROJECT_CONTACTS_DIALOGUE_ID';
//
export const GET_SCHEDULE_CONTACT_INVITE_LINK_DETAILS = 'GET_SCHEDULE_CONTACT_INVITE_LINK_DETAILS';
export const REDEEM_SCHEDULE_CONTACT_INVITE_LINK = 'REDEEM_SCHEDULE_CONTACT_INVITE_LINK';
export const REQUEST_FRESH_SCHEDULE_CONTACT_INVITE_LINK = 'REQUEST_FRESH_SCHEDULE_CONTACT_INVITE_LINK';
export const SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK = 'SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK';
export const STOP_USING_INVITE_SCHEDULE_CONTACT_LINK = 'STOP_USING_INVITE_SCHEDULE_CONTACT_LINK';

export const GET_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK_DETAILS = 'GET_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK_DETAILS';
export const REDEEM_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK = 'REDEEM_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK';
export const REQUEST_FRESH_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK = 'REQUEST_FRESH_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK';
export const SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK = 'SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK';
export const STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK = 'STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK';

export const ADD_DAILY_REPORT = 'ADD_DAILY_REPORT';
export const DELETE_DAILY_REPORT = 'DELETE_DAILY_REPORT';
export const REQUEST_UPLOAD_DAILY_REPORT_IMAGE = 'REQUEST_UPLOAD_DAILY_REPORT_IMAGE';
export const NOTIFY_UPLOADED_DAILY_REPORT_IMAGE = 'NOTIFY_UPLOADED_DAILY_REPORT_IMAGE';
export const GET_DAILY_REPORT = 'GET_DAILY_REPORT';
export const GET_DAILY_REPORT_SUMMARIES = 'GET_DAILY_REPORT_SUMMARIES';
export const SET_NEW_DAILY_REPORT_DIALOGUE_ID = 'SET_NEW_DAILY_REPORT_DIALOGUE_ID';
export const SET_EDIT_DAILY_REPORT_DIALOGUE_ID = 'SET_EDIT_DAILY_REPORT_DIALOGUE_ID';
export const SET_DELETE_DAILY_REPORT_DIALOGUE_ID = 'SET_DELETE_DAILY_REPORT_DIALOGUE_ID';

export const HEARTBEAT = 'HEARTBEAT';
export const SET_LAST_INTERACTION_TIME = 'SET_LAST_INTERACTION_TIME';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const LOAD_UPDATED_CLIENT = 'LOAD_UPDATED_CLIENT';
export const MAX_TIMESTAMP = 7258000000000;

export const SET_GANON_VISIBLE = 'SET_GANON_VISIBLE';

export const SET_IS_TOUCH_DEVICE = 'SET_IS_TOUCH_DEVICE';
export const SET_APP_FOCUSED = 'SET_APP_FOCUSED';
export const PUSH_BROWSER_HISTORY_STATE = 'PUSH_BROWSER_HISTORY_STATE';
export const POP_BROWSER_HISTORY_STATE = 'POP_BROWSER_HISTORY_STATE';

export const SET_PRIVACY_POLICY_DIALOGUE_OPEN = 'SET_PRIVACY_POLICY_DIALOGUE_OPEN';
export const SET_TERMS_OF_USE_DIALOGUE_OPEN = 'SET_TERMS_OF_USE_DIALOGUE_OPEN';
export const SET_WELCOME_DIALOGUE_OPEN = 'SET_WELCOME_DIALOGUE_OPEN';

export const SET_FEEDBACK_DIALOGUE_OPEN = 'SET_FEEDBACK_DIALOGUE_OPEN';
export const SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK';

export const SET_ADMIN_DIALOGUE_OPEN = 'SET_ADMIN_DIALOGUE_OPEN';
export const SET_SITEBOARD_EMAIL_ADDRESS = 'SET_SITEBOARD_EMAIL_ADDRESS';
export const SEND_EMAIL = 'SEND_EMAIL';

export const SET_USER_ROLE_INFO_DIALOGUE_SHOWING = 'SET_USER_ROLE_INFO_DIALOGUE_SHOWING';

export const SET_USING_INVITE_LINK = 'SET_USING_INVITE_LINK';
export const STOP_USING_INVITE_LINK = 'STOP_USING_INVITE_LINK';

export const SITEBOARD_STAFF_ROLE = 'SITEBOARD_STAFF_ROLE'; // TODO: change these to put role first in the name, like SITEBOARD_ROLE_STAFF
export const SUBSCRIPTION_OWNER_ROLE = 'SUBSCRIPTION_OWNER_ROLE';
export const SUBSCRIPTION_MANAGER_ROLE = 'SUBSCRIPTION_MANAGER_ROLE';
export const PROJECT_ADMIN_ROLE = 'PROJECT_ADMIN_ROLE';
export const PROJECT_MEMBER_ROLE = 'PROJECT_MEMBER_ROLE';
export const PROJECT_VIEWER_ROLE = 'PROJECT_VIEWER_ROLE';

export const LOG_POSTCARD1_PROMO_LINK_VISITED = 'LOG_POSTCARD1_PROMO_LINK_VISITED';

export const PROMO_CODE_CREATE = 'PROMO_CODE_CREATE';
export const PROMO_CODE_DELETE = 'PROMO_CODE_DELETE';
export const PROMO_CODE_SET_NOTE = 'PROMO_CODE_SET_NOTE';
export const PROMO_CODE_SET_EXPIRATION = 'PROMO_CODE_SET_EXPIRATION';
export const PROMO_CODE_SET_DISABLED = 'PROMO_CODE_SET_DISABLED';
export const PROMO_CODE_REDEEM = 'PROMO_CODE_REDEEM';
export const PROMO_CODE_FETCH_ALL = 'PROMO_CODE_FETCH_ALL';
export const SET_DELETE_PROMO_CODE_DIALOGUE_OPEN = 'SET_DELETE_PROMO_CODE_DIALOGUE_OPEN';
export const REQUEST_PROMO_SIGNUP_CODE = 'REQUEST_PROMO_SIGNUP_CODE';
export const CHECK_PROMO_SIGNUP_CODE = 'CHECK_PROMO_SIGNUP_CODE';
export const SET_NOTE_PROMO_CODE_DIALOGUE_OPEN = 'SET_NOTE_PROMO_CODE_DIALOGUE_OPEN';
export const SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN = 'SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN';
export const SET_USING_PROMO_SIGNUP_LINK = 'SET_USING_PROMO_SIGNUP_LINK';
export const STOP_USING_PROMO_SIGNUP_LINK = 'STOP_USING_PROMO_SIGNUP_LINK';

export const SETUP_LOCAL_SESSION = 'SETUP_LOCAL_SESSION';
export const SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN = 'SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN';
export const REQUEST_SCHEDULE_EMAIL_UPDATES = 'REQUEST_SCHEDULE_EMAIL_UPDATES';

export const ADDITIONAL_USER_DESCRIPTION = 'An additional user is any individual added as a Project Member, Project Admin, or Account Manager. A person can be assigned to multiple projects/roles and still counts as only a single additional user.';

export const isObject = (obj) => {
  if (obj === null) { return false; }
  if (typeof obj !== 'object') { return false; }
  if (Array.isArray(obj)) { return false; }
  return true;
};

export const isArray = (obj) => {
  if (obj === null) { return false; }
  if (typeof obj !== 'object') { return false; }
  return Array.isArray(obj);
};

export function DataAttribute(Class, dataKey, description, defaultValueIfMissing) {
  const THIS = this;
  //if (typeof Class !== 'function') throw new Error('Data Item invalid sub-class');
  if (typeof description !== 'string' || description.length === 0) throw new Error(Class.name + ' invalid description');
  if (typeof dataKey !== 'string' || dataKey.length === 0) throw new Error(description + ' invalid data key');

  this.getDataKey = function () { return dataKey; };
  this.toDynamo = function (value) {
    return Class.toDynamo(typeof value === 'undefined' ? defaultValueIfMissing : value, description);
  };
  this.fromDynamo = function (dynamoValue) {
    if(typeof dynamoValue === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      return Class.validate(defaultValueIfMissing, description);
    }
    return Class.fromDynamo(dynamoValue, description);
  };
  this.validate = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }
    return Class.validate(value, description);
  };
  THIS.isValid = function (value) {
    try {
      THIS.validate(value);
      return true;
    } catch(error) {}
    return false;
  };
  THIS.getDescription = () => { return description; }
}

export function DataList(Class, dataKey, description, defaultValueIfMissing) {
  const THIS = this;
  if (!isObject(Class) && typeof Class !== 'function') throw new Error('Data List invalid sub-class');
  if (typeof description !== 'string' || description.length === 0) throw new Error(Class.name + ' invalid description');
  if (typeof dataKey !== 'string' || dataKey.length === 0) throw new Error(description + ' invalid data key');

  THIS.getDataKey = function () { return dataKey; };
  THIS.toDynamo = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }

    const dynamoList = [];
    for (const item of THIS.validate(value)) {
      dynamoList.push(Class.toDynamo(item));
    }
    return { L: dynamoList };
  };
  THIS.fromDynamo = function (dynamoValue) {
    if(typeof dynamoValue === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      return THIS.validate(defaultValueIfMissing);
    }

    if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + description);
    if (!isArray(dynamoValue.L)) throw new Error('Please provide a list for ' + description);

    const validList = [];
    for (const item of dynamoValue.L) {
      validList.push(Class.validate(Class.fromDynamo(item)));
    }
    return validList;
  };
  THIS.validate = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }
    if (!isArray(value)) throw new Error('Please provide ' + description + ' list in a valid format');
    const validList = [];
    for(const item of value) {
      validList.push(Class.validate(item));
    }
    return validList;
  };
  THIS.isValid = function (value) {
    try {
      THIS.validate(value);
      return true;
    } catch(error) {}
    return false;
  };
  THIS.getDescription = () => { return description; }
}

export function DataObject(mapSchema, dataKey, description, defaultValueIfMissing) {
  const THIS = this;
  if (!isArray(mapSchema)) throw new Error('Data Map invalid schema');
  if (typeof description !== 'string' || description.length === 0) throw new Error('Data Map invalid description');
  if (typeof dataKey !== 'string' || dataKey.length === 0) throw new Error(description + ' invalid data key');

  THIS.getDataKey = function () { return dataKey; };
  THIS.toDynamo = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }

    const validValue = THIS.validate(value);
    const dynamoMap = { M: {} };
    for (const schemaAttribute of mapSchema) {
      dynamoMap.M[schemaAttribute.getDataKey()] = schemaAttribute.toDynamo(validValue[schemaAttribute.getDataKey()]);
    }

    return dynamoMap;
  };
  THIS.fromDynamo = function (dynamoValue) {
    if(typeof dynamoValue === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      return THIS.validate(defaultValueIfMissing);
    }

    if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + description);
    if (!isObject(dynamoValue.M)) throw new Error('Please provide a map for ' + description);
    const validMap = {};
    for (const schemaAttribute of mapSchema) {
      validMap[schemaAttribute.getDataKey()] = schemaAttribute.fromDynamo(dynamoValue.M[schemaAttribute.getDataKey()]);
    }
    return validMap;
  };
  THIS.validate = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }
    if (!isObject(value)) throw new Error('Please provide ' + description + ' in a valid format');
    const validMap = {};
    for (const schemaAttribute of mapSchema) {
      validMap[schemaAttribute.getDataKey()] = schemaAttribute.validate(value[schemaAttribute.getDataKey()]);
    }
    return validMap;
  };
  THIS.isAttributeValid = function (attributeName, attributeValue) {
    for (const schemaAttribute of mapSchema) {
      if(schemaAttribute.getDataKey() !== attributeName) continue;
      return schemaAttribute.isValid(attributeValue);
    }
    return false;
  };
  THIS.isValid = function (value) {
    try {
      THIS.validate(value);
      return true;
    } catch(error) {}
    return false;
  };
  THIS.getDescription = () => { return description; }
}

export function DataMap(keyValidator, valueValidator, dataKey, description, defaultValueIfMissing) {
  const THIS = this;
  if (typeof description !== 'string' || description.length === 0) throw new Error('Data Map invalid description');
  if (typeof dataKey !== 'string' || dataKey.length === 0) throw new Error(description + ' invalid data key');

  if(!isObject(keyValidator) && typeof keyValidator !== 'function') throw new Error('Invalid key validator for DataMap [1] - ' + description);
  if(typeof keyValidator.toDynamo !== 'function') throw new Error('Invalid key validator for DataMap [2] - ' + description);
  if(typeof keyValidator.fromDynamo !== 'function') throw new Error('Invalid key validator for DataMap [3] - ' + description);
  if(typeof keyValidator.validate !== 'function') throw new Error('Invalid key validator for DataMap [4] - ' + description);
  if(typeof keyValidator.isValid !== 'function') throw new Error('Invalid key validator for DataMap [5] - ' + description);
  
  if(!isObject(valueValidator) && typeof valueValidator !== 'function') throw new Error('Invalid value validator for DataMap [1] - ' + description);
  if(typeof valueValidator.toDynamo !== 'function') throw new Error('Invalid value validator for DataMap [2] - ' + description);
  if(typeof valueValidator.fromDynamo !== 'function') throw new Error('Invalid value validator for DataMap [3] - ' + description);
  if(typeof valueValidator.validate !== 'function') throw new Error('Invalid value validator for DataMap [4] - ' + description);
  if(typeof valueValidator.isValid !== 'function') throw new Error('Invalid value validator for DataMap [5] - ' + description);

  THIS.getDataKey = function () { return dataKey; };
  THIS.toDynamo = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }

    const validValue = THIS.validate(value);
    const dynamoMap = { M: {} };
    for (const key in validValue) {
      dynamoMap.M[key] = valueValidator.toDynamo(validValue[key]);
    }

    return dynamoMap;
  };
  THIS.fromDynamo = function (dynamoValue) {
    if(typeof dynamoValue === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      return THIS.validate(defaultValueIfMissing);
    }

    if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + description);
    if (!isObject(dynamoValue.M)) throw new Error('Please provide a map for ' + description);
    const dataMap = {};
    for (const key in dynamoValue.M) {
      dataMap[key] = valueValidator.fromDynamo(dynamoValue.M[key]);
    }
    return THIS.validate(dataMap);
  };
  THIS.validate = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }
    if (!isObject(value)) throw new Error('Please provide ' + description + ' in a valid format');
    const validMap = {};
    for (const key in value) {
      const validKey = keyValidator.validate(key);
      const validValue = valueValidator.validate(value[key]);
      validMap[validKey] = validValue;
    }
    return validMap;
  };
  THIS.isValid = function (value) {
    try {
      THIS.validate(value);
      return true;
    } catch(error) {}
    return false;
  };
  THIS.getDescription = () => { return description; }
}

export function DataAttributeOrEmptyString(Class, dataKey, description, defaultValueIfMissing) {
  const THIS = this;
  //if (typeof Class !== 'function') throw new Error('Data Item invalid sub-class');
  if (typeof description !== 'string' || description.length === 0) throw new Error(Class.name + ' invalid description');
  if (typeof dataKey !== 'string' || dataKey.length === 0) throw new Error(description + ' invalid data key');

  this.getDataKey = function () { return dataKey; };
  this.toDynamo = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }
    if(value === '') return { S: '' };
    return Class.toDynamo(value, description);
  };
  this.fromDynamo = function (dynamoValue) {
    if(typeof dynamoValue === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      return THIS.validate(defaultValueIfMissing);
    }
    if(isObject(dynamoValue) && dynamoValue.S === '') return '';
    return Class.fromDynamo(dynamoValue, description);
  };
  this.validate = function (value) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }
    if(value === '') return '';
    return Class.validate(value, description);
  };
  THIS.isValid = function (value) {
    try {
      THIS.validate(value);
      return true;
    } catch(error) {}
    return false;
  };
  THIS.getDescription = () => { return description; }
}

export const ANY_CHARACTERS_CLASS = '[\\s\\S]';
export function RegexAttribute(allowedCharsClass, minLength, maxLength, dataKey, description, defaultValueIfMissing) {
  const THIS = this;

  if (typeof allowedCharsClass !== 'string' || allowedCharsClass.length === 0) throw new Error('Invalid RegexAttribute allowedCharsClass');
  if (typeof description !== 'string' || description.length === 0) throw new Error('Invalid RegexAttribute description');
  if (typeof minLength !== 'number' || minLength < 0) throw new Error(description + ' invalid minLength');
  if (typeof maxLength !== 'number' || maxLength < minLength) throw new Error(description + ' invalid maxLength');
  if (typeof dataKey !== 'string' || dataKey.length === 0) throw new Error(description + ' invalid data key');

  THIS.getDataKey = function () { return dataKey; };
  THIS.toDynamo = function (value) {
    return { S: THIS.validate(typeof value === 'undefined' ? defaultValueIfMissing : value, description) };
  };
  THIS.fromDynamo = function (dynamoValue) {
    if(typeof dynamoValue === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      return THIS.validate(defaultValueIfMissing, description);
    }
    if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || ' RegexAttribute'));
    return THIS.validate(dynamoValue.S, description);
  };
  THIS.validate = function (value, description2) {
    if(typeof value === 'undefined' && typeof defaultValueIfMissing !== 'undefined') {
      value = defaultValueIfMissing;
    }
    description = description2 || description || 'RegexAttribute';
    if (typeof value !== 'string') throw new Error('Please enter ' + description + ' - it can be between ' + minLength + ' and ' + maxLength + ' characters long');
    if (value.length < minLength && value.length === 0) throw new Error('Please enter ' + description);
    if (value.length < minLength) throw new Error('' + description + ' must be at least ' + minLength + ' characters long');
    if (value.length > maxLength) throw new Error('' + description + ' must be less than ' + maxLength + ' characters long');
    if (value.match(new RegExp('^' + allowedCharsClass + '*$')) === null) {
      const disallowedChars = value.replaceAll(new RegExp(allowedCharsClass, 'g'), '');
      const charMap = {};
      for(let i = 0; i < disallowedChars.length; i++) {
        charMap[''+disallowedChars[i]] = '';
      }
      const disallowedCharsList = [];
      for(const key in charMap) {
        let modifiedKey = key;
        if(key === ' ') {
          modifiedKey = 'spaces';
        } else if(key === '\n') {
          modifiedKey = 'newlines';
        } else if(key === '\t') {
          modifiedKey = 'tabs';
        }
        disallowedCharsList.push(modifiedKey);
      }
      throw new Error('Your ' + description + ' contains invalid characters. Please remove ' + disallowedCharsList.join(' and '));
    }
    return value;
  };
  THIS.isValid = function (value) {
    try {
      THIS.validate(value);
      return true;
    } catch(error) {}
    return false;
  };
  THIS.getDescription = () => { return description; }
}
export const BlankString = new RegexAttribute('.', 0, 0, 'blank', 'desc', '');

export function UUID() {}
UUID.toDynamo = function (value, description) {
  return { S: UUID.validate(value, description) };
};
UUID.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || ' UUID'));
  return UUID.validate(dynamoValue.S, description);
};
UUID.validate = function (value, description) {
  description = description || 'UUID';
  if (typeof value !== 'string') throw new Error('' + description + ' appears to be invalid. Please ensure it matches the required UUID format');
  if (value.length !== 36) throw new Error('' + description + ' appears to be invalid. Please ensure it matches the required UUID format');
  // TODO: make this match actual UUID format?
  if (value.match(/^[a-fA-F0-9-]+$/) === null) throw new Error('' + description + ' appears to be invalid. Please ensure it matches the required UUID format');
  return value;
};
UUID.isValid = function (value) {
  try {
    UUID.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function UUIDOrBlank() {}
UUIDOrBlank.toDynamo = function (value, description) {
  return { S: UUIDOrBlank.validate(value, description) };
};
UUIDOrBlank.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || ' UUIDOrBlank'));
  return UUIDOrBlank.validate(dynamoValue.S, description);
};
UUIDOrBlank.validate = function (value, description) {
  description = description || 'UUIDOrBlank';
  if (value === '') return value;
  return UUID.validate(value, description);
};
UUIDOrBlank.isValid = function (value) {
  try {
    UUIDOrBlank.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function Email() {}
Email.toDynamo = function (value, description) {
  return { S: Email.validate(value, description) };
};
Email.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || ' email'));
  return Email.validate(dynamoValue.S, description);
};
Email.validate = function (value, description) {
  description = description || 'email';
  if (typeof value !== 'string' || value.length === 0) throw new Error('Please enter '+(description || 'an email') + '.');
  if (value.length > 100) throw new Error('' + description + ' must be less than 100 characters long.');
  if (value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) === null) throw new Error(description + " isn't in the correct format. Please make sure it includes an '@' symbol and a valid domain (like example@domain.com).");
  return value.trim().toLowerCase();
};
Email.isValid = function (value) {
  try {
    Email.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function CanonicalEmail() {}
CanonicalEmail.toDynamo = function (value, description) {
  return { S: CanonicalEmail.validate(value, description) };
};
CanonicalEmail.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || ' email'));
  return CanonicalEmail.validate(dynamoValue.S, description);
};
CanonicalEmail.validate = function (value, description) {
  description = description || 'email';
  const validEmail = Email.validate(value, description);
  let [local, domain] = validEmail.split('@');
  local = local.split('+')[0];
  if(validEmail.match(/.*@gmail.com$/)) {
    local = local.replace(/\./g, '');
  }
  return local+'@'+domain;
};
CanonicalEmail.isValid = function (value) {
  try {
    CanonicalEmail.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function AnyString() {}
AnyString.toDynamo = function (value, description) {
  return { S: AnyString.validate(value, description) };
};
AnyString.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || ' AnyString'));
  return AnyString.validate(dynamoValue.S, description);
};
AnyString.validate = function (value, description) {
  description = description || 'AnyString';
  if (typeof value !== 'string') throw new Error('' + description + ' is not a string');
  return value;
};
AnyString.isValid = function (value) {
  try {
    AnyString.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function NonNegativeInteger() {}
NonNegativeInteger.description = 'non-negative integer';
NonNegativeInteger.toDynamo = function (value, description) {
  return { N: '' + NonNegativeInteger.validate(value, description) };
};
NonNegativeInteger.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || NonNegativeInteger.description));
  return NonNegativeInteger.validate(parseInt(dynamoValue.N), description);
};
NonNegativeInteger.validate = function (value, description) {
  description = description || NonNegativeInteger.description;
  if (typeof value !== 'number') { throw new Error('Please provide a valid ' + description + ' - received a non-numeric value'); }
  if (!Number.isInteger(value)) { throw new Error('Please provide a valid ' + description + ' - received a non-integer value'); }
  if (value < 0) { throw new Error('Please provide a valid ' + description + ' - received a negative value'); }
  return value;
};
NonNegativeInteger.isValid = function (value) {
  try {
    NonNegativeInteger.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function UUIDMapToBlank() {}
UUIDMapToBlank.toDynamo = function (value, description) {
  const validValue = UUIDMapToBlank.validate(value, description);
  const dynamoMap = {};
  for (const key in validValue) {
    dynamoMap[key] = { S: '' };
  }
  return { M: dynamoMap };
};
UUIDMapToBlank.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'user projects'));
  const value = {};
  for (const key in dynamoValue.M) {
    value[key] = '';
  }
  return UUIDMapToBlank.validate(value, description);
};
UUIDMapToBlank.validate = function (value, description) {
  if (!isObject(value)) throw new Error('Please provide ' + (description || 'user projects') + ' in a valid format');
  const validProjects = {};
  for (const key in value) {
    const validKey = UUID.validate(key, 'user\'s project ID');
    validProjects[validKey] = '';
  }
  return validProjects;
};
UUIDMapToBlank.isValid = function (value) {
  try {
    UUIDMapToBlank.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function Bool() {}
Bool.toDynamo = function (value, description) {
  return { BOOL: Bool.validate(value, description) };
};
Bool.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'boolean'));
  return Bool.validate(dynamoValue.BOOL, description);
};
Bool.validate = function (value, description) {
  if (typeof value !== 'boolean') throw new Error('Please provide ' + (description || 'boolean') + ' in a valid format');
  return value;
};
Bool.isValid = function (value) {
  try {
    Bool.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function SessionKey() {}
SessionKey.description = 'session key';
SessionKey.toDynamo = function (value, description) {
  return { S: SessionKey.validate(value, description) };
};
SessionKey.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || SessionKey.description ));
  return SessionKey.validate(dynamoValue.S, description);
};
SessionKey.validate = function (value, description) {
  description = description || SessionKey.description;
  if (typeof value !== 'string') throw new Error('Please provide ' + description + ' in a valid format');
  if (value.length !== 512) throw new Error('The provided ' + description + ' is the wrong length');
  if (value.match(/^[0-9a-f]+$/) === null) throw new Error('The provided ' + description + ' contains invalid characters');
  return value;
};
SessionKey.isValid = function (value) {
  try {
    SessionKey.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function Timestamp() {}
Timestamp.toDynamo = function (value, description) {
  return { N: '' + Timestamp.validate(value, description) };
};
Timestamp.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'timestamp'));
  return Timestamp.validate(parseInt(dynamoValue.N), description);
};
Timestamp.validate = function (value, description) {
  description = description || 'timestamp';
  if (typeof value !== 'number') { throw new Error('Please provide a valid ' + description + ' - received a non-numeric value'); }
  if (!Number.isInteger(value)) { throw new Error('Please provide a valid ' + description + ' - received a non-integer value'); }
  if (value < 0) { throw new Error('Please provide a valid ' + description + ' - negative timestamps are not supported'); }
  // don't allow dates past 2200-01-01
  if (value > 7258118400000) { throw new Error('The provided ' + description + ' is too far in the future - please provide a timestamp before January 1, 2200'); }
  // Create a date object and verify it converts back to the same timestamp
  if (new Date(value).getTime() !== value) { throw new Error('Please provide a valid ' + description + ' - the value provided resulted in an invalid date'); }
  return value;
};
Timestamp.isValid = function (value) {
  try {
    Timestamp.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function UserName() {}
UserName.toDynamo = function (value, description) {
  return { S: UserName.validate(value, description) };
};
UserName.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'user name'));
  return UserName.validate(dynamoValue.S, description);
};
UserName.validate = function (value, description) {
  description = description || 'user name';
  if (typeof value !== 'string') throw new Error('Please enter a ' + description + ' - it can be up to 50 letters long');
  const trimmedValue = value.trim().replaceAll(/ +/g, ' '); // turn multiple spaces into a single space
  //if (trimmedValue.length === 0) throw new Error('Please enter a ' + description + ' - it can be up to 50 letters long.');
  if (trimmedValue.length > 50) throw new Error('' + description + ' must be less than 50 characters long');
  //if (trimmedValue.match(/^[a-zA-Z ]*$/) === null) throw new Error('Please use only letters in ' + description + ' - no numbers or special characters.');
  if (trimmedValue.match(/^[a-zA-Z ]*$/) === null) {
    const disallowedChars = trimmedValue.replaceAll(/[a-zA-Z ]/g, '');
    const charMap = {};
    for(let i = 0; i < disallowedChars.length; i++) {
      charMap[''+disallowedChars[i]] = '';
    }
    const disallowedCharsList = [];
    for(const key in charMap) {
      disallowedCharsList.push(key);
    }
    throw new Error(description + ' contains invalid characters. Please remove ' + disallowedCharsList.join('') + ' and use only letters and spaces');
  }
  return trimmedValue;
};
UserName.isValid = function (value) {
  try {
    UserName.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function CompanyName() {}
CompanyName.toDynamo = function (value, description) {
  return { S: CompanyName.validate(value, description) };
};
CompanyName.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'company name'));
  return CompanyName.validate(dynamoValue.S, description);
};
CompanyName.validate = function (value, description) {
  description = description || 'company name';
  if (typeof value !== 'string') throw new Error('Please enter a ' + description + ' - it can be up to 50 letters long');
  const trimmedValue = value.trim().replaceAll(/ +/g, ' '); // turn multiple spaces into a single space
  //if (trimmedValue.length === 0) throw new Error('Please enter a ' + description + ' - it can be up to 50 letters long.');
  if (trimmedValue.length > 50) throw new Error('' + description + ' must be less than 50 characters long');
  //if (trimmedValue.match(/^[a-zA-Z ]*$/) === null) throw new Error('Please use only letters in ' + description + ' - no numbers or special characters.');
  if (trimmedValue.match(/^[a-zA-Z0-9# .&'_-]*$/) === null) {
    const disallowedChars = trimmedValue.replaceAll(/[a-zA-Z0-9# .&'_-]/g, '');
    const charMap = {};
    for(let i = 0; i < disallowedChars.length; i++) {
      charMap[''+disallowedChars[i]] = '';
    }
    const disallowedCharsList = [];
    for(const key in charMap) {
      disallowedCharsList.push(key);
    }
    throw new Error('Your ' + description + ' contains invalid characters. Please remove ' + disallowedCharsList.join(' and '));
  }
  return trimmedValue;
};
CompanyName.isValid = function (value) {
  try {
    CompanyName.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function LoginCodeLong() {}
LoginCodeLong.toDynamo = function (value, description) {
  return { S: LoginCodeLong.validate(value, description) };
};
LoginCodeLong.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'login code'));
  return LoginCodeLong.validate(dynamoValue.S, description);
};
LoginCodeLong.validate = function (value, description) {
  description = description || 'login code';
  if(typeof value !== 'string') throw new Error('Please provide a ' + description);
  const trimmedValue = value.trim();
  if(trimmedValue.length !== 256) throw new Error('Your ' + description + ' is invalid, please check that you entered it correctly');
  if(trimmedValue.match(/^[0-9a-f]+$/) === null) throw new Error('Your ' + description + ' is invalid, please check that you entered it correctly');
  return trimmedValue;
};
LoginCodeLong.isValid = function (value) {
  try {
    LoginCodeLong.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function LoginCodeShort() {}
LoginCodeShort.toDynamo = function (value, description) {
  return { S: LoginCodeShort.validate(value, description) };
};
LoginCodeShort.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'login code'));
  return LoginCodeShort.validate(dynamoValue.S, description);
};
LoginCodeShort.validate = function (value, description) {
  description = description || 'login code';
  if(typeof value !== 'string') throw new Error('Please provide a ' + description);
  const trimmedValue = value.trim();
  if(trimmedValue.length !== 6) throw new Error('Your ' + description + ' is invalid, please check that you entered it correctly');
  if(trimmedValue.match(/^[abcdefghjkmnpqrstuvwxyz23456789]+$/) === null) throw new Error('Your ' + description + ' is invalid, please check that you entered it correctly');
  return trimmedValue;
};
LoginCodeShort.isValid = function (value) {
  try {
    LoginCodeShort.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function LoginCode() {}
LoginCode.toDynamo = function (value, description) {
  return { S: LoginCode.validate(value, description) };
};
LoginCode.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'login code'));
  return LoginCode.validate(dynamoValue.S, description);
};
LoginCode.validate = function (value, description) {
  try {
    return LoginCodeShort.validate(value);
  } catch(error) {}

  try {
    return LoginCodeLong.validate(value);
  } catch(error) {}

  throw new Error('Your ' + (description || 'login code') + ' is invalid, please check that you entered it correctly');
};
LoginCode.isValid = function (value) {
  try {
    LoginCode.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function LoginCodeOrBlank() {}
LoginCodeOrBlank.toDynamo = function (value, description) {
  return { S: LoginCodeOrBlank.validate(value, description) };
};
LoginCodeOrBlank.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'login code'));
  return LoginCodeOrBlank.validate(dynamoValue.S, description);
};
LoginCodeOrBlank.validate = function (value, description) {
  if (value === '') return value;
  try { return LoginCodeShort.validate(value); } catch(error) {}
  try { return LoginCodeLong.validate(value); } catch(error) {}
  throw new Error('Your ' + (description || 'login code') + ' is invalid, please check that you entered it correctly');
};
LoginCodeOrBlank.isValid = function (value) {
  try {
    LoginCodeOrBlank.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function ShareScheduleCode() {}
ShareScheduleCode.toDynamo = function (value, description) {
  return { S: ShareScheduleCode.validate(value, description) };
};
ShareScheduleCode.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'share code'));
  return ShareScheduleCode.validate(dynamoValue.S, description);
};
ShareScheduleCode.validate = function (value, description) {
  description = description || 'share code';
  if(typeof value !== 'string') throw new Error('Please provide a ' + description);
  const trimmedValue = value.trim();
  if(trimmedValue.length !== 66) throw new Error('Your ' + description + ' is invalid, please check that you entered it correctly');
  if(trimmedValue.match(/^[0-9a-zA-Z_]+$/) === null) throw new Error('Your ' + description + ' is invalid, please check that you entered it correctly');
  return trimmedValue;
};
ShareScheduleCode.isValid = function (value) {
  try {
    ShareScheduleCode.validate(value);
    return true;
  } catch(error) {}
  return false;
};
ShareScheduleCode.truncate = function (value) {
  ShareScheduleCode.validate(value);
  return value.slice(0, 6);
}

export function DateStringMMDDYYYY() {}
DateStringMMDDYYYY.toDynamo = function (value, description) {
  return { S: DateStringMMDDYYYY.validate(value, description) };
};
DateStringMMDDYYYY.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'date'));
  return DateStringMMDDYYYY.validate(dynamoValue.S, description);
};
DateStringMMDDYYYY.validate = function (value, description) {
  DateStringMMDDYYYY.toDateObject(value, description);
  return value;
};
DateStringMMDDYYYY.isValid = function (value) {
  try {
    DateStringMMDDYYYY.validate(value);
    return true;
  } catch(error) {}
  return false;
};
DateStringMMDDYYYY.toDateObject = function (value, description) {
  description = description || 'date';
  if(typeof value !== 'string') throw new Error('Please enter a ' + description);

  const match = value.match(/ *(\d+)\/(\d+)\/(\d+) *$/); // mm/dd/yyyy format
  if(!match) throw new Error('' + description + ' should be in the format mm/dd/yyyy (e.g. 01/11/2025). Please check the format and try again');

  const month = match[1];
  if(!month || typeof month !== 'string') throw new Error('Please provide a month for ' + description);
  const monthNumber = parseInt(month);
  if(month.length < 1 || month.length > 2 || isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12) throw new Error('The month you entered is invalid. Please enter a valid month (1-12) for ' + description);

  const day = match[2];
  if(!day || typeof day !== 'string') throw new Error('Please provide a day for ' + description);
  const dayNumber = parseInt(day);
  if(day.length < 1 || day.length > 2 || isNaN(dayNumber) || dayNumber < 1 || dayNumber > 31) throw new Error('The day you entered is invalid. Please enter a valid day for the selected month for ' + description);

  const year = match[3];
  if(!year || typeof year !== 'string') throw new Error('Please provide a year for ' + description);
  const yearNumber = parseInt(year);
  if(year.length !== 4 || isNaN(yearNumber) || yearNumber < 0 || yearNumber > 9999) throw new Error('The year you entered is invalid. Please enter a valid 4 digit year for ' + description);

  const dateObject = new Date();
  dateObject.setFullYear(yearNumber, monthNumber-1, dayNumber);
  dateObject.setHours(12, 0, 0, 0); // set to noon

  // check that day is valid for the current month
  const lastDayForMonth = new Date();
  lastDayForMonth.setFullYear(yearNumber, (monthNumber-1)+1, 0); // set the day of month to 0, the date object will wrap around backwards to the last day of the current month
  if(dayNumber > lastDayForMonth.getDate()) throw new Error('The day you entered is invalid. Please enter a valid day of the month for ' + description);

  return dateObject;
};

export function MapDateStringMMDDYYYYToEmpty() {}
MapDateStringMMDDYYYYToEmpty.toDynamo = function (value, description) {
  const validValue = MapDateStringMMDDYYYYToEmpty.validate(value, description);
  const dynamoMap = {};
  for (const key in validValue) {
    dynamoMap[key] = { S: '' };
  }
  return { M: dynamoMap };
};
MapDateStringMMDDYYYYToEmpty.fromDynamo = function (dynamoValue, description) {
  description = description || 'dates';
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + description);
  if (!isObject(dynamoValue.M)) throw new Error('Please provide a map for ' + description);
  const value = {};
  for (const key in dynamoValue.M) {
    value[key] = '';
  }
  return MapDateStringMMDDYYYYToEmpty.validate(value, description);
};
MapDateStringMMDDYYYYToEmpty.validate = function (value, description) {
  description = description || 'dates';
  if (!isObject(value)) throw new Error('Please provide ' + description + ' in a valid format');
  const validValue = {};
  for (const key in value) {
    const validKey = DateStringMMDDYYYY.validate(key, 'date in ' + description);
    validValue[validKey] = '';
  }
  return validValue;
};
MapDateStringMMDDYYYYToEmpty.isValid = function (value) {
  try {
    MapDateStringMMDDYYYYToEmpty.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function ProjectSchedules() {}
ProjectSchedules.toDynamo = function (value, description) {
  const validatedSchedules = ProjectSchedules.validate(value, description);
  const dynamoMap = {};
  for(const key in validatedSchedules) {
    dynamoMap[key] = { S: validatedSchedules[key] };
  }
  return { M: dynamoMap };
};
ProjectSchedules.fromDynamo = function (dynamoValue, description) {
  description = description || 'project schedules';
  if (!isObject(dynamoValue) || !isObject(dynamoValue.M)) throw new Error('Please provide a value for ' + description);

  const schedules = {};
  for(const key in dynamoValue.M) {
    if (!isObject(dynamoValue.M[key])) throw new Error('Please provide schedules in ' + description + ' in a valid format');
    schedules[key] = dynamoValue.M[key].S;
  }
  return ProjectSchedules.validate(schedules, description);
};
ProjectSchedules.validate = function (value, description) {
  description = description || 'project schedules';
  if (!isObject(value)) throw new Error('Please provide ' + description + ' in a valid format');
  const validSchedules = {};
  for (const key in value) {
    const validKey = UUID.validate(key, 'IDs in ' + description);
    const validAttribute = DateStringMMDDYYYY.validate(value[key], 'dates in ' + description);
    validSchedules[validKey] = validAttribute;
  }
  return validSchedules;
};
ProjectSchedules.isValid = function (value) {
  try {
    ProjectSchedules.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function ProjectMemberRole() {}
ProjectMemberRole.toDynamo = function (value, description) {
  return { S: ProjectMemberRole.validate(value, description) };
};
ProjectMemberRole.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || 'project member role'));
  return ProjectMemberRole.validate(dynamoValue.S, description);
};
ProjectMemberRole.validate = function (value, description) {
  description = description || 'project member role';
  if (typeof value !== 'string') throw new Error('Please provide a value for ' + description);
  if (value !== 'Owner' && value !== 'Admin' && value !== 'Member' && value !== 'Viewer' && value !== 'Removed' && value !== 'Pending') {
    throw new Error('Invalid ' + description + ' - must be either Owner, Admin, Member, or Viewer');
  }
  return value;
};
ProjectMemberRole.isValid = function (value) {
  try {
    ProjectMemberRole.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export const ProjectMember = new DataObject([
  new DataAttribute(ProjectMemberRole, 'role', 'project member role'),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'last time the member was modified'),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the member was added to the project'),
], 'project member', 'project member');

export function ProjectMemberMap() {}
ProjectMemberMap.toDynamo = function (value, description) {
  const validValue = ProjectMemberMap.validate(value, description);
  const dynamoMap = {};
  for (const key in validValue) {
    dynamoMap[key] = ProjectMember.toDynamo(validValue[key]);
  }
  return { M: dynamoMap };
};
ProjectMemberMap.fromDynamo = function (dynamoValue, description) {
  description = description || 'project members';
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + description);
  if (!isObject(dynamoValue.M)) throw new Error('Please provide a map for ' + description);
  const value = {};
  for (const key in dynamoValue.M) {
    value[key] = ProjectMember.fromDynamo(dynamoValue.M[key]);
  }
  return ProjectMemberMap.validate(value, description);
};
ProjectMemberMap.validate = function (value, description) {
  description = description || 'project members';
  if (!isObject(value)) throw new Error('Please provide ' + description + ' in a valid format');
  const validProjects = {};
  for (const key in value) {
    const validKey = UUID.validate(key, 'IDs in ' + description);
    const validAttribute = ProjectMember.validate(value[key], 'members in ' + description)
    validProjects[validKey] = validAttribute;
  }
  return validProjects;
};
ProjectMemberMap.isValid = function (value) {
  try {
    ProjectMemberMap.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export function PendingProjectMemberMap() {}
PendingProjectMemberMap.toDynamo = function (value, description) {
  const validValue = PendingProjectMemberMap.validate(value, description);
  const dynamoMap = {};
  for (const key in validValue) {
    dynamoMap[key] = ProjectMember.toDynamo(validValue[key]);
  }
  return { M: dynamoMap };
};
PendingProjectMemberMap.fromDynamo = function (dynamoValue, description) {
  description = description || 'pending project members';
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + description);
  if (!isObject(dynamoValue.M)) throw new Error('Please provide a map for ' + description);
  const value = {};
  for (const key in dynamoValue.M) {
    value[key] = ProjectMember.fromDynamo(dynamoValue.M[key]);
  }
  return PendingProjectMemberMap.validate(value, description);
};
PendingProjectMemberMap.validate = function (value, description) {
  description = description || 'pending project members';
  if (!isObject(value)) throw new Error('Please provide ' + description + ' in a valid format');
  const validValue = {};
  for (const key in value) {
    const validKey = Email.validate(key, 'Emails in ' + description);
    const validAttribute = ProjectMember.validate(value[key], 'members in ' + description)
    validValue[validKey] = validAttribute;
  }
  return validValue;
};
PendingProjectMemberMap.isValid = function (value) {
  try {
    PendingProjectMemberMap.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export const User = new DataObject([
  new DataAttribute(UUID, 'id', 'user ID'),
  new DataAttribute(Email, 'email', 'user email'),
  new DataAttribute(UserName, 'firstName', 'user first name'),
  new DataAttribute(UserName, 'lastName', 'user last name'),
  new DataAttribute(UUIDMapToBlank, 'projects', 'user projects'),
  new DataAttribute(Bool, 'isOnline', 'whether user is online'),
  new DataAttribute(Timestamp, 'lastOnlineTimestamp', 'user last online time'),
  new DataAttribute(Bool, 'isAdmin', 'is admin user', false), // admin users can create new projects // TODO: depreciate this
  new DataAttribute(UUIDOrBlank, 'ownedSubscriptionId', 'id of the subscription owned by the user', ''),
  new DataAttribute(UUIDMapToBlank, 'subscriptions', 'map of the subscriptions the user belongs to', {}),
], '#', 'user details');

export const UserPreferences = new DataObject([
  new DataAttribute(UUID, 'userId', 'user ID'),
  //new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 200, 'onboardingState', 'onboarding state', 'finished'),
  new DataAttribute(Bool, 'showWelcomeScreen', 'whether to display the welcome screen when the app starts', true),
  new DataAttribute(Bool, 'darkMode', 'whether the user prefers dark mode', true),
], '#', 'user preferences');

export const Project = new DataObject([
  new DataAttribute(UUID, 'id', 'project ID'),
  new DataAttribute(UUID, 'ownerId', 'project owner ID'), // todo: depreciate this and convert owner to admin member
  new DataAttribute(UUID, 'subscriptionId', 'subscription id for the project'),
  new RegexAttribute("[a-zA-Z0-9# .&'_-]", 0, 50, 'name', 'project name'),
  new RegexAttribute("[a-zA-Z0-9#_-]", 0, 25, 'jobNumber', 'project job number', ''),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 200, 'address', 'project address', ''),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 50, 'customer', 'project customer', ''),
  new RegexAttribute("[0-9]", 0, 20, 'dirNumber', 'project DIR#', ''),
  new DataAttributeOrEmptyString(DateStringMMDDYYYY, 'beginDate', 'notice to proceed date', ''),
  new RegexAttribute("[0-9]", 0, 10, 'calendarDays', 'project calendar days', ''),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 50, 'superintendent', 'project superintendent', ''),
  new RegexAttribute("[0-9()# -]", 0, 30, 'superintendentPhone', 'project superintendent phone number', ''),
  new DataAttribute(ProjectMemberMap, 'members', 'project members'),
  new DataAttribute(PendingProjectMemberMap, 'pendingMembers', 'project members pending invite acceptance', {}),
  new DataAttribute(ProjectSchedules, 'schedules', 'project schedules'),
  new DataAttribute(NonNegativeInteger, 'contactCount', 'how many contacts are part of the project', 0),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the project was created'),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'last time the project was modified'),
], '#', 'project details');

export const EmailLogin = new DataObject([
  new DataAttribute(Email, 'email', 'email address'),
  new DataAttribute(NonNegativeInteger, 'loginEmailsSent', 'how many login codes have been sent to this email without successfull login', 0),
  new DataAttribute(LoginCodeOrBlank, 'loginCode', 'login code'),
  new DataAttribute(NonNegativeInteger, 'loginCodeAttempts', 'how many times the login code has been guessed without successfull login', 0),
  new DataAttribute(Timestamp, 'loginCodeEmailTimestamp', 'time a login code was last sent to the email', 0),
  new DataAttribute(Timestamp, 'rateLimitResetTimestamp', 'time  since the system last reset the email code daily limit', 0),
  new DataAttribute(NonNegativeInteger, 'resetCount', 'number of times the system has reset the email code daily limit', 0),
  new DataAttribute(UUIDOrBlank, 'userId', 'user id associated with this email address', ''),
], '#', 'email login details');

export const SubscriptionInvite = new DataObject([
  new DataAttribute(Email, 'email', 'invitation recipient\'s email'),
  new DataAttribute(UUID, 'subscriptionId', 'subscription ID'),
  new DataAttribute(ProjectMemberRole, 'subscriptionRole', 'subscription member\'s role'),
  new DataAttribute(ProjectMemberMap, 'projectMemberships', 'projects and roles for the invited member', {}),
  new DataAttribute(LoginCodeLong, 'inviteCode', 'subscription invite code'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 200, 'inviterName', 'name of the inviter', ''),
  new DataAttribute(Email, 'inviterEmail', 'email of the inviter'),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the invitation was created'),
], '#', 'subscription invite');

export const Activity = new DataObject([
  new DataAttribute(UUID, 'id', 'activity ID'),
  new DataAttribute(UUID, 'scheduleId', 'activity\'s schedule ID'),
  new DataAttribute(UUID, 'projectId', 'activity\'s project ID'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 100, 'responsible', 'person responsible for the activity', ''),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 100, 'description', 'description of the activity', ''),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 500, 'generalNotes', 'general notes about the activity', ''),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 500, 'delayNotes', 'delay notes about the activity', ''),
  new DataAttribute(Bool, 'isHighPriority', 'whether activity is high priority', false),
  new DataAttribute(MapDateStringMMDDYYYYToEmpty, 'activeDates', 'dates this activity will be performed', {}),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the activity was created', 0),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'last time the activity was modified', 0),
], '#', 'activity details');

export const Schedule = new DataObject([
  new DataAttribute(UUID, 'id', 'schedule ID'),
  new DataAttribute(UUID, 'projectId', 'schedule\'s project ID'),
  new DataAttribute(DateStringMMDDYYYY, 'beginDate', 'date the schedule begins on'),
  new DataAttribute(MapDateStringMMDDYYYYToEmpty, 'weatherDates', 'dates with adverse weather', {}),
  new DataAttribute(MapDateStringMMDDYYYYToEmpty, 'holidayDates', 'dates with no work because of a holiday', {}),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 2000, 'generalNotes', 'general notes about the schedule', ''),
  new DataAttribute(Bool, 'isPublished', 'whether the schedule is published', false),
  new DataAttribute(UUID, 'publishedByUserId', 'user ID that published the schedule', '00000000-0000-0000-0000-000000000000'),
  new DataList(UUID, 'activitiesOrder', 'list of the schedule\'s activity ids', []),
  new DataAttribute(Timestamp, 'publishedTimestamp', 'time the schedule was published', 0),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the schedule was created', 0),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'last time the schedule was modified', 0),
], '#', '3 week schedule');

export const DailyReportS3Image = new DataObject([
  new DataAttribute(UUID, 'id', 'image ID'),
  new DataAttribute(UUID, 'dailyReportId', 'ID of the daily report this image belongs to'),
  new RegexAttribute(".", 1, 300, 'fullImageS3Key', 'AWS S3 bucket key where the full resolution image is stored'),
  new RegexAttribute(".", 1, 300, 'thumbnailS3Key', 'AWS S3 bucket key where the thumbnail resolution image is stored'),
  new DataAttribute(Bool, 'hasBeenUploaded', 'whether the image has been uploaded by the user yet', false),
], 'dailyReportS3Image', 'link to a daily report image stored in s3');

export const S3ImageUploadFields = new DataObject([
  new RegexAttribute(".", 1, 5000, 'Policy', 'aws s3 presigned url upload policy'),
  new RegexAttribute(".", 1, 5000, 'X-Amz-Algorithm', 'aws s3 presigned url upload X-Amz-Algorithm'),
  new RegexAttribute(".", 1, 5000, 'X-Amz-Credential', 'aws s3 presigned url upload X-Amz-Credential'),
  new RegexAttribute(".", 1, 5000, 'X-Amz-Date', 'aws s3 presigned url upload X-Amz-Date'),
  new RegexAttribute(".", 1, 5000, 'X-Amz-Security-Token', 'aws s3 presigned url upload X-Amz-Security-Token'),
  new RegexAttribute(".", 1, 5000, 'X-Amz-Signature', 'aws s3 presigned url upload X-Amz-Signature'),
  new RegexAttribute(".", 1, 5000, 'bucket', 'aws s3 presigned url upload bucket'),
  new RegexAttribute(".", 1, 5000, 'key', 'aws s3 presigned url upload key'),
], 'imageUploadFields', 'aws s3 presigned url upload fields');

export const DailyReportImage = new DataObject([
  new RegexAttribute(".", 1, 500, 'fullImageUrl', 'full image URL'),
  new RegexAttribute(".", 1, 500, 'thumbnailImageUrl', 'thumbnail image URL'),
], 'dailyReportImage', 'daily report worksite picture');

export const DailyReport = new DataObject([
  new DataAttribute(UUID, 'id', 'daily report ID'),
  new DataAttribute(UUID, 'projectId', 'daily report\'s project ID'),
  new DataAttribute(DateStringMMDDYYYY, 'date', 'daily report date'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 101, 'assignee', 'daily report\'s assignee', ''), // length must accomodate user.firstName + ' ' + user.lastName
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 50, 'weatherCondition', 'weather conditions on the report date', ''),
  new RegexAttribute("[0-9]", 0, 3, 'weatherTempF', 'weather temperature in fahrenheit on the report date', ''),
  new DataAttribute(Bool, 'hasDelays', 'whether there are delays occuring on the report date', false),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 500, 'delayNotes', 'delay notes for the daily report', ''),
  new DataAttribute(Bool, 'hasInspections', 'whether there are inspections occuring on the report date', false),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 500, 'inspectionNotes', 'inspections notes for the daily report', ''),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 2000, 'generalNotes', 'general notes about the daily report', ''),
  new DataList(DailyReportImage, 'worksitePictures', 'list of daily report worksite pictures', []),
  new DataAttribute(Bool, 'isPublished', 'whether the daily report has been published', false),
  new DataAttribute(Timestamp, 'publishedTimestamp', 'time the daily report was published', 0),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the daily report was created'),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'last time the daily report was modified'),
  //files
  //work log ids
], 'dailyReport', 'daily report detailing the work done on site for a particular day and signed off on by a superintendent');

export const DailyReportSummary = new DataObject([
  new DataAttribute(UUID, 'id', 'daily report ID'),
  new DataAttribute(UUID, 'projectId', 'daily report\'s project ID'),
  new DataAttribute(DateStringMMDDYYYY, 'date', 'daily report date'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 101, 'assignee', 'daily report\'s assignee', ''), // length must accomodate user.firstName + ' ' + user.lastName
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 50, 'weatherCondition', 'weather conditions on the report date', ''),
  new RegexAttribute("[0-9]", 0, 3, 'weatherTempF', 'weather temperature in fahrenheit on the report date', ''),
  new DataAttribute(Bool, 'hasDelays', 'whether there are delays occuring on the report date', false),
  new DataAttribute(Bool, 'hasInspections', 'whether there are inspections occuring on the report date', false),
  new DataAttribute(Bool, 'isPublished', 'whether the daily report has been published', false),
], 'dailyReportSummary', 'daily report summary with abbreviated info');

const worklogItemSchema = [
//contractor name
//quantity
//hours
//description
];

export const ContractorName = new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 100, '#', 'contractor name');
export const ContractorList = new DataObject([
  //new DataAttribute(UUID, 'id', 'contractor names list ID'),
  new DataAttribute(UUID, 'projectId', 'ID of the project this list belongs to'),
  new DataList(ContractorName, 'contractors', 'list of project contractors'),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the list of contractors was created'),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'last time the list of contractors was modified'),
], 'contractorList', 'list of contractor names that are shown in the contractor name dropdown in the daily report worklog');

export const ScheduleDeliveryStatus = new DataObject([
  new DataAttribute(Bool, 'isDelivered', 'whether the schedule has been successfully delivered'),
  new DataAttribute(Timestamp, 'timestamp', 'timestamp for last status'),
], 'scheduleDeliveryStatus', 'schedule delivery status and time');

export const ScheduleContact = new DataObject([
  new DataAttribute(Email, 'email', 'contact email'),
  new DataAttribute(UUID, 'subscriptionId', 'subscription id for the contact'),
  new DataAttribute(UserName, 'firstName', 'contact first name', ''),
  new DataAttribute(UserName, 'lastName', 'contact last name', ''),
  new DataAttribute(CompanyName, 'companyName', 'company name', ''),
  new DataMap(UUID, ScheduleDeliveryStatus, 'projectScheduleDeliveries', 'map of project ids to delivery status for latest sent schedule', {}),
  new DataAttribute(NonNegativeInteger, 'inviteResendCount', 'how many times the invite email has been resent', 0),
  new DataAttribute(Timestamp, 'latestInviteEmailTimestamp', 'latest time an invite email was sent', 0),
  new DataAttribute(Bool, 'hasSubscribed', 'whether contact has consented to receive schedule updates', false),
  new DataAttribute(Timestamp, 'subscribedTimestamp', 'time when the contact consented to receive schedule updates', 0),
  new DataAttribute(Bool, 'hasUnsubscribed', 'whether contact has opted out of schedule updates', false),
  new DataAttribute(Timestamp, 'unsubscribedTimestamp', 'time when the contact opted out of schedule updates', 0),
  new DataAttribute(Bool, 'hasBounce', 'whether this email has hard bounced and is suppressed', false),
  new DataAttribute(Timestamp, 'bounceTimestamp', 'time when the contact opted out of schedule updates', 0),
  new DataAttribute(Bool, 'hasComplaint', 'whether this email has had a complaint is suppressed', false),
  new DataAttribute(Timestamp, 'complaintTimestamp', 'time when the contact opted out of schedule updates', 0),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time when the contact was created'),
], 'scheduleContact', 'schedule contact info');
export const contactNeedsAnotherInvite = (contact) => {
  ScheduleContact.validate(contact);
  if(contact.latestInviteEmailTimestamp === 0) return false;
  if(contact.hasSubscribed === true) return false;

  const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
  const elapsedDaysSinceInvite = (new Date().getTime() - contact.latestInviteEmailTimestamp) / oneDayInMilliseconds;
  if(elapsedDaysSinceInvite > 3 && contact.inviteResendCount === 0) return true;
  if(elapsedDaysSinceInvite > 4 && contact.inviteResendCount === 1) return true;
  return false;
};

export const ScheduleMessageThreadMember = new DataObject([
  new DataAttribute(Timestamp, 'startedTypingTimestamp', 'time the user started typing', 0),
  new DataAttribute(Timestamp, 'stoppedTypingTimestamp', 'time the user stopped typing', 0),
  new DataAttribute(Timestamp, 'enteredThreadTimestamp', 'time the user entered the thread', 0),
  new DataAttribute(Timestamp, 'leftThreadTimestamp', 'time the user left the thread', 0),
  new DataAttribute(NonNegativeInteger, 'messageCount', 'how many messages the user has posted to the thread'),
], 'scheduleMessageThreadMember', 'schedule message thread');

export function ScheduleMessageThreadMemberMap() {}
ScheduleMessageThreadMemberMap.description = 'schedule message thread members';
ScheduleMessageThreadMemberMap.toDynamo = function (value, description) {
  const validatedValue = ScheduleMessageThreadMemberMap.validate(value, description);
  const dynamoMap = {};
  for(const key in validatedValue) {
    dynamoMap[key] = ScheduleMessageThreadMember.toDynamo(validatedValue[key]);
  }
  return { M: dynamoMap };
};
ScheduleMessageThreadMemberMap.fromDynamo = function (dynamoValue, description) {
  description = description || ScheduleMessageThreadMemberMap.description;
  if (!isObject(dynamoValue) || !isObject(dynamoValue.M)) throw new Error('Please provide a value for ' + description);

  const memberMap = {};
  for(const key in dynamoValue.M) {
    memberMap[key] = ScheduleMessageThreadMember.fromDynamo(dynamoValue.M[key]);
  }
  return ScheduleMessageThreadMemberMap.validate(memberMap, description);
};
ScheduleMessageThreadMemberMap.validate = function (value, description) {
  description = description || ScheduleMessageThreadMemberMap.description;
  if (!isObject(value)) throw new Error('Please provide ' + description + ' in a valid format');
  const validMemberMap = {};
  for (const key in value) {
    const validKey = UUID.validate(key, 'IDs in ' + description);
    const validAttribute = ScheduleMessageThreadMember.validate(value[key], 'member in ' + description);
    validMemberMap[validKey] = validAttribute;
  }
  return validMemberMap;
};
ScheduleMessageThreadMemberMap.isValid = function (value) {
  try {
    ScheduleMessageThreadMemberMap.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export const ScheduleMessageThread = new DataObject([
  new DataAttribute(UUID, 'id', 'schedule message thread ID'),
  new DataAttribute(UUID, 'projectId', 'ID of the project that the message thread belongs to'),
  new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the message thread belongs to'), // TODO: take this out
  new DataAttribute(ScheduleMessageThreadMemberMap, 'members', 'schedule message thread members'),
], 'scheduleMessageThread', 'schedule message thread');

export const ScheduleMessage = new DataObject([
  new DataAttribute(UUID, 'id', 'schedule message ID'),
  new DataAttribute(UUID, 'projectId', 'ID of the project that the message belongs to'),
  new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the message belongs to'), // TODO: take this out
  new DataAttribute(UUID, 'scheduleMessageThreadId', 'ID of the schedule message thread that the message belongs to'),
  new DataAttribute(UUID, 'ownerId', 'ID of the user that sent the message'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 2000, 'content', 'content of the message', ''),
  new DataAttribute(Timestamp, 'timestamp', 'time the message was sent')
], 'scheduleMessage', 'schedule message');

export const UnreadScheduleMessageThread = new DataObject([
  new DataAttribute(UUID, 'userId', 'id of the user the unread messages are for'),
  new DataAttribute(UUID, 'projectId', 'ID of the project that the message thread belongs to'),
  new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the message thread belongs to'), // TODO: take this out
  new DataAttribute(UUID, 'scheduleMessageThreadId', 'ID of the schedule message thread'),
  new DataAttribute(NonNegativeInteger, 'unreadCount', 'how many unread messages the user has in the thread'),
  new DataAttribute(Timestamp, 'earliestUnreadTimestamp', 'time of the earliest unread message in the thread'),
  new DataAttribute(Timestamp, 'latestUnreadTimestamp', 'time of the latest unread message in the thread'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 2000, 'latestMessageContent', 'content of the latest unread message', ''),
  new DataAttribute(UUID, 'latestMessageSenderId', 'id of the user that sent the latest message in the thread'),
], 'unreadScheduleMessageThread', 'info about a user\'s unread messages in a schedule message thread');

//export function SubscriptionMemberRole() {}
//SubscriptionMemberRole.description = 'subscription member role';
//SubscriptionMemberRole.toDynamo = function (value, description) {
//  return { S: SubscriptionMemberRole.validate(value, description) };
//};
//SubscriptionMemberRole.fromDynamo = function (dynamoValue, description) {
//  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || SubscriptionMemberRole.description));
//  return SubscriptionMemberRole.validate(dynamoValue.S, description);
//};
//SubscriptionMemberRole.validate = function (value, description) {
//  description = description || SubscriptionMemberRole.description;
//  if (typeof value !== 'string') throw new Error('Please provide a value for ' + description);
//  if (value !== 'Owner' && value !== 'Manager') {
//    throw new Error('Invalid ' + description + ' - must be either Owner or Manager');
//  }
//  return value;
//};
//SubscriptionMemberRole.isValid = function (value) {
//  try {
//    SubscriptionMemberRole.validate(value);
//    return true;
//  } catch(error) {}
//  return false;
//};

export function SubscriptionType() {}
SubscriptionType.description = 'subscription type';
SubscriptionType.toDynamo = function (value, description) {
  return { S: SubscriptionType.validate(value, description) };
};
SubscriptionType.fromDynamo = function (dynamoValue, description) {
  if (!isObject(dynamoValue)) throw new Error('Please provide a value for ' + (description || SubscriptionType.description));
  return SubscriptionType.validate(dynamoValue.S, description);
};
SubscriptionType.validate = function (value, description) {
  description = description || SubscriptionType.description;
  if (typeof value !== 'string') throw new Error('Please provide a value for ' + description);
  if (value !== 'Trial' && value !== 'Standard' && value !== 'Founder' && value !== 'Intent_Standard' && value !== 'Intent_None' && value !== 'Complimentary') {
    throw new Error('Invalid ' + description + ' - must be either Trial or Standard');
  }
  return value;
};
SubscriptionType.isValid = function (value) {
  try {
    SubscriptionType.validate(value);
    return true;
  } catch(error) {}
  return false;
};

export const Subscription = new DataObject([
  new DataAttribute(UUID, 'id', 'subscription ID'),
  new DataAttribute(SubscriptionType, 'type', 'subscription type'),
  new DataAttribute(Bool, 'autoRenew', 'whether the subscription automatically renews at the end of the billing period', false),
  new DataAttribute(ProjectMemberMap, 'members', 'subscription members'),
  new DataAttribute(PendingProjectMemberMap, 'pendingMembers', 'subscription members pending invite acceptance', {}),
  new DataAttribute(UUIDMapToBlank, 'projectIds', 'map of projects ids in the subscription'),
  new DataAttribute(NonNegativeInteger, 'userCount', 'number of unique users in the subscription'), // used to enforce trial limits when updating dynamodb
  new DataAttribute(NonNegativeInteger, 'projectCount', 'number of projects in the subscription'), // used to enforce trial limits when updating dynamodb
  new DataAttribute(NonNegativeInteger, 'scheduleCount', 'number of schedules in the subscription'), // used to enforce trial limits when updating dynamodb
  new DataAttribute(NonNegativeInteger, 'contactCount', 'how many contacts are part of the subscription', 0),
  new DataAttribute(NonNegativeInteger, 'discountPercent', 'percent the subscription has been discounted, 0-100', 0),
  new DataAttribute(Timestamp, 'endTimestamp', 'time when the subscription expires'),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the subscription was created'),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'last time the subscription was modified'),
  // showTutorial
  // BucketMBUsed
], '#', 'subscription');

// get the number of users that add to the subscription price. we exclude pending members and the owner from this count
export const getSubscriptionActiveAdditionalUserCount = (subscription) => {
  if(!Subscription.isValid(subscription)) return 0;
  let count = 0;
  for(const userId in subscription.members) {
    if(subscription.members[userId].role === 'Owner') continue;
    count++;
  }
  return count;
}

const getDiscountedPriceString = (price, discountPercent) => { // price in dollars, discountPercent 0-100 for percent the price has been discounted
  const discountedPriceCents = Math.round(price * (100-(discountPercent || 0)));
  let discountedPriceDollars = ''+(discountedPriceCents/100);
  if(discountedPriceDollars.match(/^\d+\.\d$/)) {
    discountedPriceDollars += '0'; // add a trailing zero if the number has cents but only one digit
  }
  return discountedPriceDollars;
};

export const getSubscriptionMonthlyPriceString = (subscription) => {
  if(!Subscription.isValid(subscription)) return 0;
  const activeUsers = getSubscriptionActiveAdditionalUserCount(subscription);
  const monthlyPrice = (STANDARD_SUBSCRIPTION_PRICE_MONTHLY + (activeUsers * STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY));
  return '$' + getDiscountedPriceString(monthlyPrice, subscription.discountPercent) + '/month';
}

export const getSubscriptionMonthlyPriceBreakdownString = (subscription) => {
  if(!Subscription.isValid(subscription)) return 0;
  const activeUsers = getSubscriptionActiveAdditionalUserCount(subscription);
  return `$${getDiscountedPriceString(STANDARD_SUBSCRIPTION_PRICE_MONTHLY, subscription.discountPercent)}` +
    ` + ${activeUsers} user${activeUsers !== 1 ? 's' : ''} @ $${getDiscountedPriceString(STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY, subscription.discountPercent)}`;
}

export const getSubscriptionOwnerId = (subscription) => {
  if(!Subscription.isValid(subscription)) return null;
  for(const memberId in subscription.members) {
    if(subscription.members[memberId].role === 'Owner') return memberId;
  }
};
export const getSubscriptionOwnerAndManagerIds = (subscription) => {
  if(!Subscription.isValid(subscription)) return [];

  const ids = [];
  for(const memberId in subscription.members) {
    if(subscription.members[memberId].role === 'Owner' || subscription.members[memberId].role === 'Admin') {
      ids.push(memberId);
    }
  }
  return ids;
};
export const isSubscriptionStarted = (subscription) => {
  if(!Subscription.isValid(subscription)) return false;
  if(subscription.type === 'Trial') return true;
  if(subscription.type === 'Standard') return true;
  if(subscription.type === 'Founder') return true;
  if(subscription.type === 'Complimentary') return true;
  return false;
}
export const assertSubscriptionIsActive = (subscription, description) => {
  description = description || 'your subscription';
  if(!Subscription.isValid(subscription)) throw new Error(description + ' is invalid');

  // Check that the subscription type is active and not a placeholder
  if(!isSubscriptionStarted(subscription)) throw new Error(description + ' has not started yet');

  // Check that the subscription is not expired
  const currentTimestamp = new Date().getTime();
  if(subscription.type === 'Trial' && currentTimestamp >= subscription.endTimestamp) {
    throw new Error('The trial period has ended for ' + description + '. Please upgrade to the Standard plan to continue.');
  }
  if(subscription.type === 'Standard' && (currentTimestamp - (STANDARD_SUBSCRIPTION_EXPIRED_GRACE_PERIOD_DAYS*1000*60*60*24)) >= subscription.endTimestamp){
    throw new Error(description + ' has expired. Please check that your payment is current to continue.');
  }
}

export const userCanAddProjectAdmin = (userId, subscription, project) => {
  if(!SiteboardApiValidator[ADD_PROJECT_MEMBER].isUserIdAuthorized(userId, subscription, project)) return false;
  const isValidSubscription = Subscription.isValid(subscription) && isSubscriptionStarted(subscription);
  const isValidProject = Project.isValid(project);
  if(isValidSubscription && isValidProject && project.subscriptionId !== subscription.id) return false;
  if(isValidSubscription && userId in subscription.members && (subscription.members[userId].role === 'Owner' || subscription.members[userId].role === 'Admin')) return true;
  return false;
}
export const userCanAddProjectMember = (userId, subscription, project) => {
  if(!SiteboardApiValidator[ADD_PROJECT_MEMBER].isUserIdAuthorized(userId, subscription, project)) return false;
  const isValidSubscription = Subscription.isValid(subscription) && isSubscriptionStarted(subscription);
  const isValidProject = Project.isValid(project);
  if(isValidSubscription && isValidProject && project.subscriptionId !== subscription.id) return false;
  if(isValidSubscription && userId in subscription.members && (subscription.members[userId].role === 'Owner' || subscription.members[userId].role === 'Admin')) return true;
  if(isValidProject && userId in project.members && project.members[userId].role === 'Admin') return true;
  return false;
}
export const userCanAddProjectViewer = (userId, subscription, project) => {
  return userCanAddProjectMember(userId, subscription, project);
}

export const userCanRemoveProjectAdmin = (userId, subscription, project) => {
  if(!SiteboardApiValidator[REMOVE_PROJECT_MEMBER].isUserIdAuthorized(userId, subscription, project)) return false;
  const isValidSubscription = Subscription.isValid(subscription) && isSubscriptionStarted(subscription);
  const isValidProject = Project.isValid(project);
  if(isValidSubscription && isValidProject && project.subscriptionId !== subscription.id) return false;
  if(isValidSubscription && userId in subscription.members && (subscription.members[userId].role === 'Owner' || subscription.members[userId].role === 'Admin')) return true;
  return false;
}
export const userCanRemoveProjectMember = (userId, subscription, project) => {
  if(!SiteboardApiValidator[REMOVE_PROJECT_MEMBER].isUserIdAuthorized(userId, subscription, project)) return false;
  const isValidSubscription = Subscription.isValid(subscription) && isSubscriptionStarted(subscription);
  const isValidProject = Project.isValid(project);
  if(isValidSubscription && isValidProject && project.subscriptionId !== subscription.id) return false;
  if(isValidSubscription && userId in subscription.members && (subscription.members[userId].role === 'Owner' || subscription.members[userId].role === 'Admin')) return true;
  if(isValidProject && userId in project.members && project.members[userId].role === 'Admin') return true;
  return false;
}
export const userCanRemoveProjectViewer = (userId, subscription, project) => {
  return userCanRemoveProjectMember(userId, subscription, project);
}

export const userCanViewProject = (userId, subscription, project) => {
  const isValidSubscription = Subscription.isValid(subscription) && isSubscriptionStarted(subscription);
  const isValidProject = Project.isValid(project);
  if(isValidSubscription && isValidProject && project.subscriptionId !== subscription.id) return false;
  if(isValidSubscription && userId in subscription.members && (subscription.members[userId].role === 'Owner' || subscription.members[userId].role === 'Admin')) return true;
  if(isValidProject && userId in project.members) return true;
  return false;
};

export const StripeCustomerId = new RegexAttribute(ANY_CHARACTERS_CLASS, 10, 100, 'stripeCustomerId', 'stripe customer ID');
export const StripeSubscriptionId = new RegexAttribute(ANY_CHARACTERS_CLASS, 10, 100, 'stripeSubscriptionId', 'stripe subscription ID');
export const StripeSubscriptionInfo = new DataObject([
  StripeSubscriptionId,
  StripeCustomerId,
  new DataAttribute(UUID, 'subscriptionId', 'subscription ID'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 100, 'promotionCode', 'stripe promotion code ID', '')

  // initial checkout id
  // first payment timestamp
  // latest payment timestamp
  // total lifetime amount paid
], '#', 'stripe information for subscription');

export const VisitedPromoLinkEvent = new DataObject([
  new DataAttribute(UUID, 'id', 'event id'),
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 1000, 'name', 'description of the promo link', ''),
  new DataAttribute(Timestamp, 'timestamp', 'time the link was visited'),
  new DataAttribute(AnyString, 'event', 'stringified json for the lambda event'),
], '#', 'visited promo link');

export const PromoCode = new DataObject([
  new DataAttribute(UUID, 'id', 'id of the promo code'),
  new DataAttribute(ShareScheduleCode, 'code', 'code used to redeem the promo'),
  new DataAttribute(Email, 'creatorEmail', 'email of the promo creator'),
  new DataAttributeOrEmptyString(Email, 'redeemedEmail', 'email of the promo redeemer', ''),
  new RegexAttribute('[a-zA-Z ]', 0, 30, 'promoType', 'type of promotion'), // value of type can be: Complimentary
  new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 50, 'note', 'note about the promo code', ''),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the promo code was created'),
  new DataAttribute(Timestamp, 'modifiedTimestamp', 'time the promo code was last modified'),
  new DataAttribute(Timestamp, 'redeemedTimestamp', 'time the promo code was redeemed', 0),
  new DataAttribute(Timestamp, 'expiresAtTimestamp', 'time when the promo code expires'),
], 'promoCode', 'code to redeem a promotional deal');

export const PublishedSchedule = new DataObject([
  new DataAttribute(Schedule, 'schedule', 'the schedule that was published'),
  new DataList(Activity, 'activities', 'list of activities for the schedule'),
  new DataAttribute(Project, 'project', 'the project for the schedule that was published'),
  new DataAttribute(Timestamp, 'publishedTimestamp', 'time the project was published'),
], '#', 'complete schedule data at time of being published');

export const ShareScheduleLink = new DataObject([
  new DataAttribute(UUID, 'id', 'the share link id'),
  new DataAttribute(UUID, 'scheduleId', 'the schedule id'),
  new DataAttribute(UUID, 'projectId', 'the project id for the schedule'),
  new DataAttribute(ShareScheduleCode, 'shareCode', 'the schedule share code'),
  new DataAttribute(Timestamp, 'createdTimestamp', 'time the shared link was created'),
  new DataAttribute(Bool, 'isForScheduleContact', 'whether this link is intended to be used by a schedule contact', false),
  new DataAttributeOrEmptyString(Email, 'contactEmail', 'schedule contact email', ''),
], '#', 'allows non-logged in users to access a schedule using a code');

export const ContactSharedScheduleStats = new DataObject([
  new DataAttribute(Email, 'email', 'contact email'),
  new DataAttribute(UUID, 'scheduleId', 'schedule ID'),
  new DataAttribute(UUID, 'subscriptionId', 'subscription id for the contact and schedule'),
  new DataAttribute(Bool, 'isDelivered', 'whether email has received successfull delivery feedback from SES', false),
  new DataAttribute(Timestamp, 'deliveredTimestamp', 'time the email was delivered', 0),
  new DataAttribute(Bool, 'isViewed', 'whether the schedule share link code was used', false),
  new DataAttribute(Timestamp, 'viewedTimestamp', 'when the schedule share link code was used', 0),
  new DataAttribute(Bool, 'isConfirmed', 'whether the recipient confirmed their work dates through the shared schedule link', false),
  new DataAttribute(Timestamp, 'confirmedTimestamp', 'when the recipient confirmed their schedule work dates', 0),
], '#', 'info about a shared schedule link that has been email to a contact');

const ApiType = new RegexAttribute("[a-zA-Z_0-9]", 1, 100, 'type', 'api action type')
export const RestApiActionType = new RegexAttribute("[a-zA-Z_0-9]", 1, 100, 'action', 'api action type');

export function ApiFunction(type, description, inputSchema, outputSchema, permittedRoles, rateLimit) {
  const THIS = this;
  THIS.getType = () => { return type; }
  THIS.validateInput = (inputParams) => {
    if(!isObject(inputParams)) throw new Error('Please provide ' + description + ' in a valid format');
    const validInputs = {};
    for(const attribute of inputSchema) {
      validInputs[attribute.getDataKey()] = attribute.validate(inputParams[attribute.getDataKey()]);
    }
    return validInputs;
  }
  THIS.validateOutput = (outputParams) => {
    if(!isObject(outputParams)) throw new Error('Server provided ' + description + ' in an invalid format');
    const validOutputs = {};
    for(const attribute of outputSchema) {
      validOutputs[attribute.getDataKey()] = attribute.validate(outputParams[attribute.getDataKey()]);
    }
    return validOutputs;
  }
  THIS.isUserIdAuthorized = (userId, subscription, project) => {
    if(!UUID.isValid(userId)) return false;
    if(!isArray(permittedRoles)) return false;
    const isValidSubscription = Subscription.isValid(subscription) && isSubscriptionStarted(subscription);
    const isValidProject = Project.isValid(project);

    if(isValidSubscription && isValidProject && project.subscriptionId !== subscription.id) return false;

    for(const permittedRole of permittedRoles) {
      if(permittedRole === SUBSCRIPTION_OWNER_ROLE && isValidSubscription && userId in subscription.members && subscription.members[userId].role === 'Owner') {
        return true;
      } else if(permittedRole === SUBSCRIPTION_MANAGER_ROLE && isValidSubscription && userId in subscription.members && subscription.members[userId].role === 'Admin') {
        return true;
      } else if(permittedRole === PROJECT_ADMIN_ROLE && isValidProject && userId in project.members && project.members[userId].role === 'Admin') {
        return true;
      } else if(permittedRole === PROJECT_MEMBER_ROLE && isValidProject && userId in project.members && project.members[userId].role === 'Member') {
        return true;
      } else if(permittedRole === PROJECT_VIEWER_ROLE && isValidProject && userId in project.members && project.members[userId].role === 'Viewer') {
        return true;
      }
    }

    return false;
  };
}

const siteboardApiList = [
  // local client functions
  new ApiFunction(SET_PATH, 'Set the path for the application. The path determines which which page is currently showing.',
    [new RegexAttribute(".", 0, 100, 'path', 'the app path')], [],
  ),
  new ApiFunction(SET_LAST_VIEWED_PROJECT, 'Stores the project id for the last viewed project',
    [new DataAttribute(UUID, 'projectId', 'project id for the last viewed project')], [],
  ),
  new ApiFunction(SET_EDIT_CONTRACTORS_DIALOGUE_ID, 'Set the project id for the dialogue used to edit the list of contractors names (used in daily reports) for a given project',
    [new DataAttribute(UUID, 'projectId', 'id for the project containing the list of contractor names')], [],
  ),
  new ApiFunction(SET_NEW_DAILY_REPORT_DIALOGUE_ID, 'Set the daily report project id for the dialogue used to create a new daily report',
    [new DataAttribute(UUID, 'projectId', 'id of the project containing daily report')], [],
  ),
  new ApiFunction(SET_EDIT_DAILY_REPORT_DIALOGUE_ID, 'Set the daily report project id for the dialogue used to edit a daily report',
    [new DataAttribute(UUID, 'dailyReportId', 'id of the daily report to be edited')], [],
  ),
  new ApiFunction(SET_DELETE_DAILY_REPORT_DIALOGUE_ID, 'Set the daily report id for the dialogue used to delete a daily report',
    [new DataAttribute(UUID, 'dailyReportId', 'id of the daily report to be deleted')], [],
  ),
  new ApiFunction(SET_PRIVACY_POLICY_DIALOGUE_OPEN, 'Set whether the privacy policy window is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the privacy policy window is open')], [],
  ),
  new ApiFunction(SET_WELCOME_DIALOGUE_OPEN, 'Set whether the welcome dialogue for a new free trial user is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the free trial welcome dialogue popup is open')], [],
  ),
  new ApiFunction(SET_UNREAD_MESSAGES_DIALOGUE_OPEN, 'Set whether the unread messages window is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the unread messages window is open')], [],
  ),
  new ApiFunction(SET_TERMS_OF_USE_DIALOGUE_OPEN, 'Set whether the terms of use window is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the terms of use window is open')], [],
  ),
  new ApiFunction(SET_FEEDBACK_DIALOGUE_OPEN, 'Set whether the feedback window is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the feedback window is open')], [],
  ),
  new ApiFunction(SET_ADMIN_DIALOGUE_OPEN, 'Set whether the admin window is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the admin window is open')], [],
  ),
  new ApiFunction(SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN, 'Set whether the upgrade to standard subscription window is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the upgrade to standard subscription window is open')], [],
  ),
  new ApiFunction(SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN, 'Set whether the subscription chooser window, for users with no subscription to sign up, is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the subscription chooser window window is open')], [],
  ),
  new ApiFunction(SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN, 'Set whether the window to manage subscription account managers is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the window to manage subscription account managers is open')], [],
  ),
  new ApiFunction(SET_DELETE_CONTACT_DIALOGUE_OPEN, 'Set whether the window to delete a schedule contact is open',
    [
      new DataAttribute(Email, 'email', 'email of the contact to be deleted'),
      new DataAttribute(UUID, 'projectId', 'project id the contact is to be deleted from'),
      new DataAttribute(Bool, 'isOpen', 'whether the window is open')
    ], [],
  ),
  new ApiFunction(SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN, 'Set whether the window to confirm work dates for a schedule shared with a project contact is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the window is open'),
      new DataAttribute(Email, 'email', 'email for the schedule contact'),
      new DataAttribute(UserName, 'firstName', 'first name for the schedule contact'),
      new DataAttribute(UserName, 'lastName', 'last name for the schedule contact'),
      new DataAttribute(CompanyName, 'companyName', 'company name for the schedule contact'),
      new DataAttribute(ShareScheduleCode, 'shareCode', 'the schedule share code'),
    ], [],
  ),
  new ApiFunction(SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN, 'Set whether the window to review which schedule contacts viewed a shared schedule is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the window is open'),
      new DataAttribute(UUIDOrBlank, 'scheduleId', 'id of the schedule', ''),
    ], [],
  ),
  new ApiFunction(SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN, 'Set whether the window to review which schedule contacts confirmed a shared schedule is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the window is open'),
      new DataAttribute(UUIDOrBlank, 'scheduleId', 'id of the schedule', ''),
    ], [],
  ),
  new ApiFunction(SET_SHARE_SCHEDULE_CONFIRMED, 'Set whether the user has confirmed their work dates for the current shared schedule',
    [
      new DataAttribute(Bool, 'isConfirmed', 'whether the current shared schedule has been confirmed'),
    ], [],
  ),
  new ApiFunction(SET_PROJECT_CONTACTS_DIALOGUE_ID, 'Set the project id for the project contacts dialogue',
    [new DataAttribute(UUIDOrBlank, 'projectId', 'project id for the project contacts dialogue')], [],
  ),
  new ApiFunction(SET_SCHEDULE_MESSAGES_DIALOGUE_ID, 'Set the project and thread id for the schedule messages dialogue',
    [
      new DataAttribute(UUID, 'projectId', 'project id for the schedule messages dialogue'),
      new DataAttribute(UUID, 'scheduleMessageThreadId', 'schedule message thread id to initially display in the the schedule messages dialogue'),
    ], [],
  ),
  new ApiFunction(SET_SITEBOARD_EMAIL_ADDRESS, 'Set the email siteboard email address for this user',
    [new DataAttribute(Email, 'email', 'siteboard email address')], [],
  ),
  new ApiFunction(SET_LAST_INTERACTION_TIME, 'Set a timestamp for when the user last interacted with the app via a mouse or keyboard click',
    [new DataAttribute(Timestamp, 'timestamp', 'time when the user last interacted with the app')], [],
  ),
  new ApiFunction(SET_IS_TOUCH_DEVICE, 'Set whether this device has used a touch event',
    [new DataAttribute(Bool, 'isTouchDevice', 'whether the device has used touch events')], [],
  ),
  new ApiFunction(SET_ALERT, 'Show a popup alert message',
    [new DataAttribute(AnyString, 'message', 'the alert message')], [],
  ),
  new ApiFunction(SET_LOADING, 'Show a loading message that blocks interaction with the app',
    [new DataAttribute(AnyString, 'message', 'the loading message')], [],
  ),
  new ApiFunction(ADD_UNREAD_SCHEDULE_MESSAGE_THREAD, 'Add an unread schedule message thread object to the local state',
    [
      ApiType,
      UnreadScheduleMessageThread
    ],
    [UnreadScheduleMessageThread],
  ),
  new ApiFunction(ADD_ALL_UNREAD_SCHEDULE_MESSAGE_THREADS, 'Add a list of unread schedule message thread object to the local state',
    [
      ApiType,
      new DataList(UnreadScheduleMessageThread, 'unreadScheduleMessageThreads', 'list of unread schedule message threads')
    ],
    [new DataList(UnreadScheduleMessageThread, 'unreadScheduleMessageThreads', 'list of unread schedule message threads')],
  ),
  new ApiFunction(SET_APP_FOCUSED, 'Set whether the application window/tab is currently open and in the foreground',
    [new DataAttribute(Bool, 'isFocused', 'whether the app is focused')], [],
  ),
  new ApiFunction(PUSH_BROWSER_HISTORY_STATE, 'Track pushing a state to the window.history object to enable back button functionality',
    [
      new RegexAttribute("[a-zA-Z0-9#_-]", 0, 50, 'url', 'relative url to of the browser history state display in the browser url bar', ''),
    ], 
    [
      new DataAttribute(UUID, 'stateId', 'id of the browser history state being pushed'),
    ],
  ),
  new ApiFunction(SET_EDIT_PROJECT_DIALOGUE_ID, 'Set the project id for the dialogue used to edit or create a project',
    [
      new DataAttribute(AnyString, 'projectId', 'id of the project, or "new" to create a new project'),
      new DataAttribute(AnyString, 'tabName', 'name of the project settings tab to view upon opening', 'Details'),
    ], [],
  ),
  new ApiFunction(SET_NEW_PROJECT_DIALOGUE_SHOWING, 'Set whether the popup dialogue to create a new project is showing',
    [new DataAttribute(Bool, 'isOpen', 'whether the popup is showing'),], [],
  ),
  new ApiFunction(SET_DELETE_PROJECT_DIALOGUE_ID, 'Set the project id for the dialogue used to delete a project',
    [new DataAttribute(UUIDOrBlank, 'projectId', 'id of the project to delete')], [],
  ),
  new ApiFunction(SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID, 'Set the project id for the dialogue used to edit project members',
    [new DataAttribute(UUIDOrBlank, 'projectId', 'id of the project')], [],
  ),
  new ApiFunction(ADD_ALL_SUBSCRIPTIONS, 'Add a list of subscription objects to the local state',
    [
      ApiType,
      new DataList(Subscription, 'subscriptions', 'list of subscriptions')
    ],
    [new DataList(Subscription, 'subscriptions', 'list of subscriptions')],
  ),
  new ApiFunction(SET_USER_ROLE_INFO_DIALOGUE_SHOWING, 'Set whether user role info window is open',
    [new DataAttribute(Bool, 'isOpen', 'whether the user role info is open')], [],
  ),
  new ApiFunction(SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING, 'Set whether the window displaying info about a just joined subscription is open',
    [new DataAttribute(UUIDOrBlank, 'subscriptionId', 'id of the just joined subscription')], [],
  ),
  new ApiFunction(SET_SHARE_LINK_DIALOGUE_SHOWING, 'Set whether the window for sharing a schedule link is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the window is open'),
      new DataAttribute(UUIDOrBlank, 'scheduleId', 'id of the schedule', ''),
    ], [],
  ),
  new ApiFunction(SET_USING_INVITE_LINK, 'Save invite link information from url to trigger invite signup screen',
    [
      new DataAttribute(LoginCode, 'inviteCode', 'the invite code'),
      new DataAttribute(Email, 'inviteEmail', 'the email of the invite recipient'),
    ], [],
  ),
  new ApiFunction(STOP_USING_INVITE_LINK, 'Clear invite link information',
    [], [],
  ),
  new ApiFunction(SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK, 'Save invite schedule contact link information from url to trigger invite signup screen',
    [
      new DataAttribute(LoginCode, 'inviteCode', 'the invite code'),
      new DataAttribute(Email, 'inviteEmail', 'the email of the invite recipient'),
    ], [],
  ),
  new ApiFunction(STOP_USING_INVITE_SCHEDULE_CONTACT_LINK, 'Clear invite link information',
    [], [],
  ),
  new ApiFunction(SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK, 'Save unsubscribe schedule contact link information from url to trigger unsubscribe screen',
    [
      new DataAttribute(LoginCode, 'unsubscribeCode', 'the unsubscribe code'),
      new DataAttribute(Email, 'unsubscribeEmail', 'the email of the unsubscribe recipient'),
    ], [],
  ),
  new ApiFunction(SET_USING_SHARE_SCHEDULE_LINK, 'Save share schedule link information from url to trigger shared schedule screen',
    [
      new DataAttribute(ShareScheduleCode, 'shareCode', 'the share schedule code'),
    ], [],
  ),
  new ApiFunction(STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK, 'Clear unsubscribe link information',
    [], [],
  ),
  new ApiFunction(SET_USING_PROMO_SIGNUP_LINK, 'Save promo code link information from url to trigger promo signup screen',
    [
      new DataAttribute(ShareScheduleCode, 'promoCode', 'promo code'),
    ], [],
  ),
  new ApiFunction(STOP_USING_PROMO_SIGNUP_LINK, 'Clear promo code link information to stop using promo signup screen',
    [], [],
  ),
  new ApiFunction(ADD_TEMPORARY_ACTIVITY, 'Add an activity optimistically on the client with a temporary id that will be replaced by the server generated id later',
    [
      new DataAttribute(Activity, 'activity', 'the temporary activity to be added'),
    ],
    [],
  ),
  new ApiFunction(REPLACE_TEMPORARY_ACTIVITY_ID, 'Replace a temporary activity id with the server generated id',
    [
      new DataAttribute(UUID, 'temporaryActivityId', 'id generated locally for temporary use'),
      new DataAttribute(UUID, 'serverGeneratedId', 'id the server generated for the activity'),
    ], [],
  ),
  new ApiFunction(SETUP_LOCAL_SESSION, 'Init local only mode',
    [
      new DataAttribute(UUID, 'userId', 'id of the local user'),
      new DataList(User, 'users', 'initial users'),
      new DataList(Activity, 'activities', 'initial activities'),
      new DataList(Project, 'projects', 'initial projects'),
      new DataList(Schedule, 'schedules', 'initial schedules'),
      new DataList(Subscription, 'subscriptions', 'initial subscriptions'),
      new DataAttribute(UserPreferences, 'userPreferences', 'initial user preferences'),
    ], [],
  ),
  new ApiFunction(SET_EDIT_SCHEDULE_DIALOGUE_SHOWING, 'Set whether the window to set a new schedule date is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the window is open'),
      new DataAttribute(UUIDOrBlank, 'scheduleId', 'id of the schedule', ''),
    ], [],
  ),
  new ApiFunction(SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING, 'Set whether the window to confirm the schedule has been unlocked is open',
    [ new DataAttribute(Bool, 'isOpen', 'whether the window is open'), ], [],
  ),
  new ApiFunction(SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING, 'Set whether the window to confirm the schedule has been published is open',
    [ new DataAttribute(Bool, 'isOpen', 'whether the window is open'), ], [],
  ),
  new ApiFunction(SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN, 'Set whether the window to request schedule email updates is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the window is open'),
    ], [],
  ),
  new ApiFunction(SET_DELETE_PROMO_CODE_DIALOGUE_OPEN, 'Set whether the popup to delete a promo code open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the popup is open'),
      new DataAttribute(UUIDOrBlank, 'promoCodeId', 'id of the promo code to delete'),
    ], [],
  ),
  new ApiFunction(SET_NOTE_PROMO_CODE_DIALOGUE_OPEN, 'Set whether the popup to set a promo code note is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the popup is open'),
      new DataAttribute(UUIDOrBlank, 'promoCodeId', 'id of the promo code to set a note for'),
    ], [],
  ),
  new ApiFunction(SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN, 'Set whether the popup to set a promo code expiration time is open',
    [
      new DataAttribute(Bool, 'isOpen', 'whether the popup is open'),
      new DataAttribute(UUIDOrBlank, 'promoCodeId', 'id of the promo code to set a note for'),
    ], [],
  ),
  new ApiFunction(SET_PREFERS_PROJECTS_LIST_VIEW, 'Set whether the user prefers list view on the all projects page',
    [
      new DataAttribute(Bool, 'prefersProjectsListView', 'whether the user prefers list view'),
    ],
    [],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),

  // rest api functions
  new ApiFunction(REQUEST_LOGIN_CODE, 'Request that a login code be emailed to an existing user',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
    ],
    [], //if(data.action !== 'loginCodeEmailed' && data.action !== 'loginCodeExists') {
  ),
  new ApiFunction(REQUEST_TRIAL_SIGNUP_CODE, 'Request that a trial signup code be emailed to a new user',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(UserName, 'firstName', 'your first name'),
      new DataAttribute(UserName, 'lastName', 'your last name'),
    ],
    [], //if(data.action !== 'loginCodeEmailed' && data.action !== 'loginCodeExists') {
  ),
  new ApiFunction(REQUEST_STANDARD_SIGNUP_CODE, 'Request that a standard signup code be emailed to a new user',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(UserName, 'firstName', 'your first name'),
      new DataAttribute(UserName, 'lastName', 'your last name'),
    ],
    [], //if(data.action !== 'loginCodeEmailed' && data.action !== 'loginCodeExists') {
  ),
  new ApiFunction(REQUEST_PROMO_SIGNUP_CODE, 'Request that a promo signup code be emailed to a new user',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(UserName, 'firstName', 'your first name'),
      new DataAttribute(UserName, 'lastName', 'your last name'),
      new DataAttribute(ShareScheduleCode, 'promoCode', 'promo code'),
    ],
    [], //if(data.action !== 'loginCodeEmailed' && data.action !== 'loginCodeExists') {
  ),
  new ApiFunction(CHECK_LOGIN_CODE, 'Send the login code that was emailed to the user back to the server to verify their identity and finish logging in',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(LoginCode, 'loginCode', 'login code'),
    ],
    [
      new DataAttribute(SessionKey, 'sessionKey', 'the user\'s session key'),
      new DataAttribute(User, 'user', 'the user object'),
    ],
  ),
  new ApiFunction(CHECK_TRIAL_SIGNUP_CODE, 'Verify signup code and create a trial subscription',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(LoginCode, 'loginCode', 'verification code'),
      new DataAttribute(UserName, 'firstName', 'user first name'),
      new DataAttribute(UserName, 'lastName', 'user last name'),
    ],
    [
      new DataAttribute(SessionKey, 'sessionKey', 'the user\'s session key'),
      new DataAttribute(User, 'user', 'the user object'),
    ],
  ),
  new ApiFunction(CHECK_STANDARD_SIGNUP_CODE, 'Verify signup code and start process for a creating a standard subscription',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(LoginCode, 'loginCode', 'verification code'),
      new DataAttribute(UserName, 'firstName', 'user first name'),
      new DataAttribute(UserName, 'lastName', 'user last name'),
    ],
    [
      new DataAttribute(SessionKey, 'sessionKey', 'the user\'s session key'),
      new DataAttribute(User, 'user', 'the user object'),
    ],
  ),
  new ApiFunction(CHECK_PROMO_SIGNUP_CODE, 'Verify signup code and start process for a creating a promotional subscription',
    [
      RestApiActionType,
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(LoginCode, 'loginCode', 'verification code'),
      new DataAttribute(UserName, 'firstName', 'user first name'),
      new DataAttribute(UserName, 'lastName', 'user last name'),
      new DataAttribute(ShareScheduleCode, 'promoCode', 'promo code'),
    ],
    [
      new DataAttribute(SessionKey, 'sessionKey', 'the user\'s session key'),
      new DataAttribute(User, 'user', 'the user object'),
    ],
  ),
  new ApiFunction(REDEEM_SUBSCRIPTION_INVITE_LINK, 'Accept a subscription invite link and create a new user if needed',
    [
      RestApiActionType,
      new DataAttribute(Email, 'inviteEmail', 'invite recipient\'s email'),
      new DataAttribute(LoginCode, 'inviteCode', 'invite code'),
      new DataAttribute(UserName, 'firstName', 'your first name'), // can be blank if user already exists
      new DataAttribute(UserName, 'lastName', 'your last name'), // can be blank if user already exists
    ],
    [
      new DataAttribute(SessionKey, 'sessionKey', 'the user\'s session key'),
      new DataAttribute(User, 'user', 'the user object'),
    ],
  ),
  new ApiFunction(GET_SUBSCRIPTION_INVITE_LINK_DETAILS, 'Get details about a subscription invite link',
    [
      RestApiActionType,
      new DataAttribute(Email, 'inviteEmail', 'invite recipient\'s email'),
      new DataAttribute(LoginCode, 'inviteCode', 'invite code'),
    ],
    [
      new DataAttribute(Bool, 'isExpired', 'whether the invite has expired'),
      new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 200, 'inviterName', 'name of the inviter', ''),
      new DataAttribute(Email, 'inviterEmail', 'email of the inviter', ''),
      new DataAttribute(Bool, 'isExistingUser', 'whether the invite belongs to an existing user'),
      new DataAttribute(Bool, 'isAccountManager', 'whether the invite includes an account manager assignment'),
      new DataList(AnyString, 'projectNames', 'list of project names included in the invite'),
    ],
  ),
  new ApiFunction(REQUEST_FRESH_SUBSCRIPTION_INVITE_LINK, 'Request a new subscription invite link be mailed to replace an expired one',
    [
      RestApiActionType,
      new DataAttribute(Email, 'inviteEmail', 'invite recipient\'s email'),
      new DataAttribute(LoginCode, 'inviteCode', 'invite code'),
    ],
    [],
  ),
  new ApiFunction(GET_SCHEDULE_CONTACT_INVITE_LINK_DETAILS, 'Get details about a schedule contact invite link',
    [
      RestApiActionType,
      new DataAttribute(Email, 'inviteEmail', 'invite recipient\'s email'),
      new DataAttribute(LoginCode, 'inviteCode', 'invite code'),
    ],
    [
      new DataAttribute(Bool, 'isExpired', 'whether the invite has expired'),
      new DataAttribute(Bool, 'alreadyRedeemed', 'whether the invite has already been redeemed'),
      new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 200, 'inviterName', 'name of the inviter', ''),
      new DataAttribute(Email, 'inviterEmail', 'email of the inviter', ''),
      new DataList(new RegexAttribute("[a-zA-Z0-9# .&'_-]", 0, 50, '#', '#'), 'projectNames', 'project names'),
      new DataAttribute(Bool, 'isExistingUser', 'whether the invite belongs to an existing user'),
    ],
  ),
  new ApiFunction(REDEEM_SCHEDULE_CONTACT_INVITE_LINK, 'Accept a schedule contact invite link',
    [
      RestApiActionType,
      new DataAttribute(Email, 'inviteEmail', 'invite recipient\'s email'),
      new DataAttribute(LoginCode, 'inviteCode', 'invite code'),
      new DataAttribute(UserName, 'firstName', 'your first name'),
      new DataAttribute(UserName, 'lastName', 'your last name'),
      new DataAttribute(CompanyName, 'companyName', 'your company name'),
    ],
    [
      new DataList(new RegexAttribute("[a-zA-Z0-9# .&'_-]", 0, 50, '#', '#'), 'sentScheduleProjectNames', 'names of projects for which schedules have just been emailed'),
    ],
  ),
  new ApiFunction(REQUEST_FRESH_SCHEDULE_CONTACT_INVITE_LINK, 'Request a new schedule contact invite link be mailed to replace an expired one',
    [
      RestApiActionType,
      new DataAttribute(Email, 'inviteEmail', 'invite recipient\'s email'),
      new DataAttribute(LoginCode, 'inviteCode', 'invite code'),
    ],
    [],
  ),
  new ApiFunction(GET_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK_DETAILS, 'Get details about a schedule contact unsubscribe link',
    [
      RestApiActionType,
      new DataAttribute(Email, 'unsubscribeEmail', 'unsubscriber\'s email'),
      new DataAttribute(LoginCode, 'unsubscribeCode', 'unsubscribe code'),
    ],
    [
      new DataAttribute(Bool, 'isExpired', 'whether the unsubscribe link has expired'),
      new DataAttribute(Bool, 'alreadyUnsubscribed', 'whether the contact already unsubscribed'),
      new DataList(new RegexAttribute("[a-zA-Z0-9# .&'_-]", 0, 50, '#', '#'), 'projectNames', 'project names'),
    ],
  ),
  new ApiFunction(REDEEM_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK, 'Request from a schedule contact to unsubscribe from schedule update emails',
    [
      RestApiActionType,
      new DataAttribute(Email, 'unsubscribeEmail', 'unsubscriber\'s email'),
      new DataAttribute(LoginCode, 'unsubscribeCode', 'unsubscribe code'),
    ],
    [],
  ),
  new ApiFunction(REQUEST_FRESH_SCHEDULE_CONTACT_UNSUBSCRIBE_LINK, 'Request that a new schedule contact unsubscribe link be mailed to replace an expired one',
    [
      RestApiActionType,
      new DataAttribute(Email, 'unsubscribeEmail', 'unsubscriber\'s email'),
      new DataAttribute(LoginCode, 'unsubscribeCode', 'unsubscribe code'),
    ],
    [],
  ),
  new ApiFunction(REDEEM_SHARE_SCHEDULE_LINK, 'Get schedule with a share code',
    [
      RestApiActionType,
      new DataAttribute(ShareScheduleCode, 'shareCode', 'the schedule share code'),
    ],
    [
      new DataAttribute(Bool, 'needContactInfo', 'whether the contact need to provide their info before viewing the schedule', false),
      new DataAttributeOrEmptyString(Email, 'contactEmail', 'contact email'),
      new DataAttributeOrEmptyString(UserName, 'contactFirstName', 'contact first name'),
      new DataAttributeOrEmptyString(UserName, 'contactLastName', 'contact last name'),
      new DataAttributeOrEmptyString(CompanyName, 'contactCompanyName', 'contact company name'),
      new DataAttribute(Bool, 'isConfirmed', 'whether the contact associated with the shared schedule link has confirmed their scheduled work dates', false),
      new DataAttributeOrEmptyString(Schedule, 'schedule', 'the schedule'),
      new DataList(Activity, 'activities', 'list of activities for the schedule'),
      new DataAttributeOrEmptyString(Project, 'project', 'the project for the schedule'),
    ],
  ),
  new ApiFunction(REDEEM_SHARE_SCHEDULE_LINK_INVITE, 'Opt in to receive schedule email updates using a share schedule link sent to a schedule contact',
    [
      RestApiActionType,
      new DataAttribute(ShareScheduleCode, 'shareCode', 'the schedule share code'),
      new DataAttribute(UserName, 'firstName', 'your first name'),
      new DataAttribute(UserName, 'lastName', 'your last name'),
      new DataAttribute(CompanyName, 'companyName', 'your company name'),
    ],
    [],
  ),
  new ApiFunction(CONFIRM_SHARE_SCHEDULE_DATES, 'Confirm work dates for a shared schedule link sent to a schedule contact',
    [
      RestApiActionType,
      new DataAttribute(ShareScheduleCode, 'shareCode', 'the schedule share code'),
      new DataAttribute(Bool, 'isConfirmed', 'whether the contact associated with the shared schedule link is confirming their scheduled work dates'),
    ],
    [
      new DataAttribute(Bool, 'isConfirmed', 'whether the contact associated with the shared schedule link has confirmed their scheduled work dates'),
    ],
  ),
  new ApiFunction(FETCH_SCHEDULE_PDF, 'Get a pdf in base64 format for the specified schedule from the server',
    [
      RestApiActionType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(SessionKey, 'sessionKey', 'the user\'s session key'),
      new DataAttribute(UUID, 'projectId', 'project ID for the project containing the schedule'),
      new DataAttribute(UUID, 'scheduleId', 'ID for the schedule'),
    ],
    [new DataAttribute(AnyString, 'pdfBase64', 'pdf for the schedule in base64 format')],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(LOGOUT, 'Log the user out of their server session',
    [
      RestApiActionType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(SessionKey, 'sessionKey', 'the user\'s session key'),
    ],
    [],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(LOG_POSTCARD1_PROMO_LINK_VISITED, 'Request the server log that a promo link has been visited',
    [RestApiActionType,],
    [],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(REQUEST_SCHEDULE_EMAIL_UPDATES, 'Request to receive email updates for a shared link schedule',
    [
      RestApiActionType,
      new DataAttribute(ShareScheduleCode, 'shareCode', 'the schedule share code'),
      new DataAttribute(UserName, 'firstName', 'your first name'),
      new DataAttribute(UserName, 'lastName', 'your last name'),
      new DataAttribute(CompanyName, 'companyName', 'your company name'),
      new DataAttribute(Email, 'email', 'your email'),
      new DataAttribute(UUID, 'projectId', 'the project id for the schedule'),
    ],
    [
      new DataAttribute(Bool, 'emailSentSuccessfully', 'whether a validation email was sent to the requester'),
      new DataAttribute(Bool, 'noMoreEmailsAllowed', 'whether the requester cannot receive more validations emails'),
      new DataAttribute(Bool, 'emailCoolingDown', 'whether the requester must wait before another validation email can be sent'),
      new DataAttribute(NonNegativeInteger, 'cooldownSecondsRemaining', 'number of seconds requester must wait before another validation email can be sent'),
    ],
  ),

  // websocket api functions
  new ApiFunction(ADD_PROJECT, 'Add a new project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(Project, 'project', 'the new project to be added'),
    ],
    [
      new DataAttribute(Project, 'project', 'the project that was added'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription associated with the project'),
      new DataAttribute(User, 'user', 'the updated user'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE],
  ),
  new ApiFunction(EDIT_PROJECT, 'Edit project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(Project, 'project', 'the edited project'),
    ],
    [
      new DataAttribute(Project, 'project', 'the project that was edited'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE],
  ),
  new ApiFunction(DELETE_PROJECT, 'Delete a project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(Project, 'project', 'the project to be deleted'),
    ],
    [
      new DataAttribute(UUID, 'projectId', 'the project id that was deleted'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription associated with the project'),
      new DataList(User, 'users', 'the updated users that were in the project'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE],
  ),
  new ApiFunction(ADD_SUBSCRIPTION_ADMIN, 'Add an account manager to a subscription',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the id of the subscription the manager will be added to'),
      new DataAttribute(Email, 'email', 'the account manager\'s email'),
    ],
    [
      //new DataAttribute(User, 'user', 'the new user'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
      new DataList(Project, 'projects', 'projects in joined subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE],
  ),
  new ApiFunction(REMOVE_SUBSCRIPTION_ADMIN, 'Remove an account manager from a subscription',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the id of the subscription the manager will be removed from'),
      new DataAttribute(UUID, 'removedMemberId', 'the id of the account manager to be removed'),
    ],
    [
      new DataAttribute(User, 'user', 'the updated user'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE],
  ),
  new ApiFunction(REMOVE_PENDING_SUBSCRIPTION_ADMIN, 'Remove a pending account manager from a subscription',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the id of the subscription the manager will be removed from'),
      new DataAttribute(Email, 'removedMemberEmail', 'the email of the invited account manager'),
    ],
    [
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE],
  ),
  new ApiFunction(ADD_PROJECT_MEMBER, 'Add a new member to a project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      new DataAttribute(Email, 'email', 'the email address of the new project member'),
      new DataAttribute(ProjectMemberRole, 'role', 'the new member\'s role'),
    ],
    [
      new DataAttribute(User, 'user', 'the new user'),
      new DataAttribute(Project, 'project', 'the updated project'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE],
  ),
  new ApiFunction(CHANGE_PROJECT_MEMBER_ROLE, 'Change a project member\'s role',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      new DataAttribute(UUID, 'memberId', 'id of the member that will change role'),
      new DataAttribute(ProjectMemberRole, 'newRole', 'the member\'s new role'),
    ],
    [
      new DataAttribute(Project, 'project', 'the updated project'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE],
  ),
  new ApiFunction(CHANGE_PENDING_PROJECT_MEMBER_ROLE, 'Change a pending project member\'s role',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      new DataAttribute(Email, 'memberEmail', 'email of the pending member that will change role'),
      new DataAttribute(ProjectMemberRole, 'newRole', 'the member\'s new role'),
    ],
    [
      new DataAttribute(Project, 'project', 'the updated project'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE],
  ),
  new ApiFunction(REMOVE_PROJECT_MEMBER, 'Remove a member from a project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      new DataAttribute(UUID, 'memberId', 'id of the member to be removed from the project'),
    ],
    [
      new DataAttribute(User, 'user', 'the updated user that was removed'),
      new DataAttribute(Project, 'project', 'the updated project'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE],
  ),
  new ApiFunction(REMOVE_PENDING_PROJECT_MEMBER, 'Remove a pending member from a project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      new DataAttribute(Email, 'removedMemberEmail', 'email of the pending member to be removed'),
    ],
    [
      new DataAttribute(Project, 'project', 'the updated project'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE],
  ),
  new ApiFunction(ADD_SCHEDULE, 'Add a schedule to a project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
      new DataAttribute(Schedule, 'schedule', 'the new schedule to add'),
      new DataAttribute(Bool, 'isCopyingFromSchedule', 'whether to copy activites from another schedule'),
      new DataAttribute(UUID, 'copyFromSchedulId', 'schedule id to copy activities from'),
    ],
    [
      new DataAttribute(Project, 'project', 'the updated project that the schedule was added to'),
      new DataAttribute(Schedule, 'schedule', 'the schedule that was added'),
      new DataList(Activity, 'activities', 'the activites in the schedule'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(EDIT_SCHEDULE, 'Edit a schedule',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
      new DataAttribute(Schedule, 'schedule', 'the updated schedule'),
    ],
    [
      new DataAttribute(Schedule, 'schedule', 'the updated schedule'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(DELETE_SCHEDULE, 'Delete a schedule from a project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'scheduleId', 'the schedule id to delete'),
    ],
    [
      new DataAttribute(UUID, 'scheduleId', 'the schedule id that was deleted'),
      new DataAttribute(Project, 'project', 'the updated project'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(PUBLISH_SCHEDULE, 'Publish a schedule',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'scheduleId', 'the schedule id to publish'),
      new DataAttribute(Bool, 'useEmailWhitelist', 'whether to send to only specific emails', false),
      new DataList(Email, 'whitelistedEmails', 'send only to these emails', []),
    ],
    [
      new DataAttribute(Schedule, 'schedule', 'the updated schedule'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(UNPUBLISH_SCHEDULE, 'Unpublish a schedule',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'scheduleId', 'the schedule id to unpublish'),
    ],
    [
      new DataAttribute(Schedule, 'schedule', 'the updated schedule'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(GET_SCHEDULE, 'Get a schedule from a project',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'scheduleId', 'the schedule id to get'),
    ],
    [
      new DataAttribute(Schedule, 'schedule', 'the requested schedule'),
      new DataList(Activity, 'activities', 'the schedule\'s activities'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(ADD_ACTIVITY, 'Add an activity to a schedule',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
      new DataAttribute(Activity, 'activity', 'the activity to be added'),
    ],
    [
      new DataAttribute(Activity, 'activity', 'the activity that was added'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(EDIT_ACTIVITY, 'Edit an activity',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
      new DataAttribute(Activity, 'activity', 'the updated activity'),
    ],
    [
      new DataAttribute(Activity, 'activity', 'the updated activity'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(DELETE_ACTIVITY, 'Delete an activity from a schedule',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'activityId', 'the id of the activity to be deleted'),
      new DataAttribute(UUID, 'scheduleId', 'the id of the schedule containing the activity'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
      new DataAttribute(UUID, 'subscriptionId', 'the project subscription id'),
    ],
    [
      new DataAttribute(UUID, 'activityId', 'the activity id that was deleted'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(ADD_SCHEDULE_MESSAGE_THREAD, 'Add a schedule message thread',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'ID of the project that the message thread belongs to'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      //new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the message thread belongs to'),
      new DataList(UUID, 'memberIds', 'list of user ids for members of the new message thread'),
    ],
    [ScheduleMessageThread],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(GET_SCHEDULE_MESSAGE_THREADS, 'Get all the schedule message threads for a schedule',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'ID of the project that the schedule belongs to'),
      //new DataAttribute(UUID, 'scheduleId', 'ID of the schedule for which to get the message threads'),
    ],
    [
      new DataList(ScheduleMessageThread, 'scheduleMessageThreads', 'list of schedule message threads for the schedule'),
      new DataList(ScheduleMessage, 'scheduleMessages', 'list of schedule messages that can be displayed for the thread preview'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(ADD_SCHEDULE_MESSAGE, 'Add a message to a schedule message thread',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'ID of the project that the message belongs to'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      //new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the message belongs to'),
      new DataAttribute(UUID, 'scheduleMessageThreadId', 'ID of the schedule message thread that the message belongs to'),
      new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 2000, 'content', 'content of the message', '')
    ],
    [
      new DataAttribute(ScheduleMessage, 'scheduleMessage', 'the new schedule message'),
      new DataAttribute(ScheduleMessageThread, 'scheduleMessageThread', 'the updated schedule message thread'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(GET_SCHEDULE_MESSAGES, 'Get all the messages for a schedule message thread',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'ID of the project that the schedule message thread belongs to'),
      //new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the schedule message thread belongs to'),
      new DataAttribute(UUID, 'scheduleMessageThreadId', 'ID of the schedule message thread'),
      new DataAttribute(Timestamp, 'fetchBeforeTimestamp', 'timestamp of the earliest message the client has and needs messages before'),
    ],
    [new DataList(ScheduleMessage, 'scheduleMessages', 'list of schedule messages in the thread')],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(ENTER_SCHEDULE_MESSAGE_THREAD, 'Inform the server that the user has entered the specified schedule message thread',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'ID of the project that the schedule message thread belongs to'),
      //new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the schedule message thread belongs to'),
      new DataAttribute(UUID, 'scheduleMessageThreadId', 'ID of the schedule message thread'),
    ],
    [
      new DataAttribute(UUID, 'userId', 'id of the user that entered the thread'),
      new DataAttribute(ScheduleMessageThread, 'scheduleMessageThread', 'the updated schedule message thread'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(LEAVE_SCHEDULE_MESSAGE_THREAD, 'Inform the server that the user has left the specified schedule message thread',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'ID of the project that the schedule message thread belongs to'),
      //new DataAttribute(UUID, 'scheduleId', 'ID of the schedule that the schedule message thread belongs to'),
      new DataAttribute(UUID, 'scheduleMessageThreadId', 'ID of the schedule message thread'),
    ],
    [
      new DataAttribute(UUID, 'userId', 'id of the user that left the thread'),
      new DataAttribute(ScheduleMessageThread, 'scheduleMessageThread', 'the updated schedule message thread'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(GET_PROJECT_CONTRACTORS, 'Get a list of contractor names that will populate the dropdown list in the daily reports worklog',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'daily report\'s project ID'),
    ],
    [ContractorList],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(SET_PROJECT_CONTRACTORS, 'Set the list of contractor names that will populate the dropdown list in the daily reports worklog',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      ContractorList,
    ],
    [ContractorList],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(GET_PROJECT_SCHEDULE_CONTACTS, 'Get the list of email contacts that are notified when a project schedule is published',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'id of the project the contacts are associated with'),
    ],
    [
      new DataAttribute(UUID, 'projectId', 'id of the project the contacts are associated with'),
      new DataAttribute(UUID, 'subscriptionId', 'id of the subscription the contacts are associated with'),
      new DataAttribute(NonNegativeInteger, 'projectContactCount', 'how many contacts are in the project', 0),
      new DataAttribute(NonNegativeInteger, 'subscriptionContactCount', 'how many contacts are in the subscription', 0),
      new DataList(ScheduleContact, 'contacts', 'new contacts for the project'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(GET_CONTACT_SHARED_SCHEDULE_STATS, 'Get stats about who viewed/confirmed a schedule that has been emailed to project contacts',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'scheduleId', 'id of the schedule'),
      new DataAttribute(UUID, 'projectId', 'id of the schedule\'s project'),
    ],
    [
      new DataList(ContactSharedScheduleStats, 'contactSharedScheduleStats', 'list of info about whether a contact viewed/confirmed the shared schedule'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(ADD_PROJECT_SCHEDULE_CONTACTS, 'Adds to the of email contacts that are notified when a project schedule is published',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'id of the project the contacts are associated with'),
      new DataList(Email, 'emails', 'emails to add the contact list'),
    ],
    [
      new DataAttribute(UUID, 'projectId', 'id of the project the contacts are associated with'),
      new DataAttribute(UUID, 'subscriptionId', 'id of the subscription the contacts are associated with'),
      new DataAttribute(NonNegativeInteger, 'projectContactCount', 'how many contacts are in the project', 0),
      new DataAttribute(NonNegativeInteger, 'subscriptionContactCount', 'how many contacts are in the subscription', 0),
      new DataList(ScheduleContact, 'contacts', 'new contacts for the project'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(DELETE_PROJECT_SCHEDULE_CONTACT, 'Delete one of the email contacts that are notified when a project schedule is published',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'id of the project the contacts are associated with'),
      new DataAttribute(Email, 'contactEmail', 'email of the contact to be deleted'),
    ],
    [
      new DataAttribute(UUID, 'projectId', 'id of the project the contacts are associated with'),
      new DataAttribute(UUID, 'subscriptionId', 'id of the subscription the contacts are associated with'),
      new DataAttribute(NonNegativeInteger, 'projectContactCount', 'how many contacts are in the project', 0),
      new DataAttribute(NonNegativeInteger, 'subscriptionContactCount', 'how many contacts are in the subscription', 0),
      new DataAttribute(Email, 'contactEmail', 'email of the deleted contact'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(GET_SHARE_SCHEDULE_LINK, 'Get a link for sharing the schedule.',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'scheduleId', 'the schedule id'),
      new DataAttribute(UUID, 'projectId', 'the project id'),
    ],
    [
      new DataAttribute(AnyString, 'shareLink', 'the link to view the schedule'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(ADD_DAILY_REPORT, 'Create a new daily report for the project for the specified day',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'daily report\'s project ID'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      new DataAttribute(DateStringMMDDYYYY, 'reportDate', 'date of the daily report'),
    ],
    [DailyReport],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(REQUEST_UPLOAD_DAILY_REPORT_IMAGE, 'Request to upload a worksite picture for a daily report. Server will return presigned post URL for the client to upload with.',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'daily report\'s project ID'),
      new DataAttribute(UUID, 'dailyReportId', 'daily report\'s ID'),
      new RegexAttribute(".", 1, 100, 'imageName', 'image name'),
    ],
    [
      new RegexAttribute(".", 1, 1000, 'thumbnailUploadUrl', 'AWS S3 presigned post url for the image thumbnail'),
      new RegexAttribute(".", 1, 1000, 'imageUploadUrl', 'AWS S3 presigned post url for the full image'),
      new DataAttribute(S3ImageUploadFields, 'thumbnailUploadFields', 'AWS S3 presigned post fields for the image thumbnail'),
      new DataAttribute(S3ImageUploadFields, 'imageUploadFields', 'AWS S3 presigned post fields for the full image'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(NOTIFY_UPLOADED_DAILY_REPORT_IMAGE, 'Notify the server that the client is finished using the AWS S3 presigned post urls to upload its daily report image(s)',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'daily report\'s project ID'),
      new DataAttribute(UUID, 'dailyReportId', 'daily report\'s ID'),
    ],
    [],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE],
  ),
  new ApiFunction(GET_DAILY_REPORT_SUMMARIES, 'Get a list of daily report\'s with abbreviated info for a given project to populate the daily report list',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'project ID for the project containing the daily reports'),
    ],
    [
      new DataList(DailyReportSummary, 'dailyReportSummaries', 'list of daily report summaries'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(GET_DAILY_REPORT, 'Get a daily report',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'project ID for the project containing the daily report'),
      new DataAttribute(UUID, 'dailyReportId', 'ID for the requested daily report'),
    ],
    [DailyReport],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(DELETE_DAILY_REPORT, 'Delete a daily report',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UUID, 'projectId', 'project ID for the project containing the daily report'),
      new DataAttribute(UUID, 'subscriptionId', 'the subscription id for the project'),
      new DataAttribute(UUID, 'dailyReportId', 'ID for the daily report to be deleted'),
    ],
    [
      new DataAttribute(UUID, 'dailyReportId', 'ID for the daily report that was deleted'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE],
  ),
  // non-project actions
  new ApiFunction(CREATE_TRIAL_SUBSCRIPTION, 'Create a trial subscription for the user',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [
      new DataAttribute(User, 'user', 'the updated user'),
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
      new DataAttribute(UserPreferences, 'userPreferences', 'the updated user preferences'),
    ],
    [SUBSCRIPTION_OWNER_ROLE],
  ),
  new ApiFunction(CREATE_STANDARD_SUBSCRIPTION_CHECKOUT, 'Get a Stripe checkout url to pay for a standard subscription',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [
      new DataAttribute(AnyString, 'checkoutUrl', 'the Stripe checkout url to pay for a standard subscription')
    ],
    [SUBSCRIPTION_OWNER_ROLE],
  ),
  new ApiFunction(CANCEL_PENDING_STANDARD_SUBSCRIPTION, 'Cancel a pending Standard subscription so that the signup flow defaults to choosing a subscription plan',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [
      new DataAttribute(Subscription, 'subscription', 'the updated subscription'),
    ],
    [SUBSCRIPTION_OWNER_ROLE],
  ),
  new ApiFunction(CREATE_STRIPE_PORTAL_SESSION, 'Get a Stripe portal url to manage an existing subscription',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [
      new DataAttribute(AnyString, 'portalUrl', 'the Stripe portal url to manage the user\'s subscription')
    ],
    [SUBSCRIPTION_OWNER_ROLE],
  ),
  new ApiFunction(SET_STARTUP_WELCOME_ENABLED, 'Set whether the welcome popup is displayed when the window loads',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(Bool, 'enabled', 'whether startup welcome screen is enabled'),
    ],
    [
      new DataAttribute(UserPreferences, 'userPreferences', 'the updated user preferences'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(SET_DARK_MODE, 'Set whether the dark mode is enable for the 3-week schedule',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(Bool, 'enabled', 'whether dark mode is enabled'),
    ],
    [
      new DataAttribute(UserPreferences, 'userPreferences', 'the updated user preferences'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(SUBMIT_FEEDBACK, 'Submit the user\'s feedback about the app',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new RegexAttribute(".", 0, 200, 'path', 'the current app path'),
      new RegexAttribute(ANY_CHARACTERS_CLASS, 2, 2000, 'feedbackText', 'Your feedback'),
    ],
    [],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(SEND_EMAIL, 'Send an email',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(Email, 'emailRecipient', 'email recipient'),
      new RegexAttribute(".", 0, 100, 'emailTitle', 'email title text'),
      new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 2000, 'emailBody', 'email body text'),
    ],
    [],
    [SITEBOARD_STAFF_ROLE],
  ),
  new ApiFunction(GET_SUBSCRIPTION_INVITES, 'Fetch subscription invites for the user',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [
      new DataList(SubscriptionInvite, 'subscriptionInvites', 'subscription invites for the user'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(ACCEPT_SUBSCRIPTION_INVITE, 'Accept a subscription invite',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(SubscriptionInvite, 'subscriptionInvite', 'subscription invite the user is accepting'),
    ],
    [
      new DataAttribute(Subscription, 'subscription', 'the joined subscription'),
      new DataList(Project, 'projects', 'projects in joined subscription'),
      new DataList(User, 'users', 'users in the joined subscription'),
      new DataAttribute(UUID, 'newMemberId', 'id of the new subscription member'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(REJECT_SUBSCRIPTION_INVITE, 'Reject a subscription invite',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(SubscriptionInvite, 'subscriptionInvite', 'subscription invite the user is rejecting'),
    ],
    [
      new DataAttribute(Subscription, 'subscription', 'the updated subscription that was rejected'),
      new DataList(Project, 'projects', 'the updated projects that were rejected'),
    ],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(SET_NAME, 'Update the user\'s name',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(UserName, 'firstName', 'your first name'),
      new DataAttribute(UserName, 'lastName', 'your last name'),
    ],
    [new DataAttribute(User, 'user', 'the updated user object')],
    [SUBSCRIPTION_OWNER_ROLE, SUBSCRIPTION_MANAGER_ROLE, PROJECT_ADMIN_ROLE, PROJECT_MEMBER_ROLE, PROJECT_VIEWER_ROLE],
  ),
  new ApiFunction(PROMO_CODE_CREATE, 'Create a promo code',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [new DataAttribute(PromoCode, 'promoCode', 'the promo code that was created')],
    [SITEBOARD_STAFF_ROLE],
  ),
  new ApiFunction(PROMO_CODE_DELETE, 'Delete a promo code',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(ShareScheduleCode, 'code', 'code to be deleted'),
    ],
    [new DataAttribute(UUID, 'promoCodeId', 'the id of the promo code that was deleted')],
    [SITEBOARD_STAFF_ROLE],
  ),
  new ApiFunction(PROMO_CODE_SET_NOTE, 'Set a note for a promo code',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(ShareScheduleCode, 'code', 'promo code to update'),
      new RegexAttribute(ANY_CHARACTERS_CLASS, 0, 50, 'note', 'note for the promo code', ''),
    ],
    [new DataAttribute(PromoCode, 'promoCode', 'the updated promo code')],
    [SITEBOARD_STAFF_ROLE],
  ),
  new ApiFunction(PROMO_CODE_SET_EXPIRATION, 'Set the expiration time for a promo code',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(ShareScheduleCode, 'code', 'promo code to update'),
      new DataAttribute(Timestamp, 'expiresAtTimestamp', 'time when the promo code expires'),
    ],
    [new DataAttribute(PromoCode, 'promoCode', 'the updated promo code')],
    [SITEBOARD_STAFF_ROLE],
  ),
  new ApiFunction(PROMO_CODE_SET_DISABLED, 'Disable the promo code by setting the expiration time to now',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
      new DataAttribute(ShareScheduleCode, 'code', 'promo code to update'),
    ],
    [new DataAttribute(PromoCode, 'promoCode', 'the updated promo code')],
    [SITEBOARD_STAFF_ROLE],
  ),
  new ApiFunction(PROMO_CODE_REDEEM, 'Only sent from the server to update a promo code that has been redeemed through the Rest API',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [new DataAttribute(PromoCode, 'promoCode', 'the updated promo code')],
    [SITEBOARD_STAFF_ROLE],
  ),
  new ApiFunction(PROMO_CODE_FETCH_ALL, 'Fetch all promo codes',
    [
      ApiType,
      new DataAttribute(UUID, 'userId', 'id of the user making the request'),
    ],
    [new DataList(PromoCode, 'promoCodes', 'list of promo codes')],
    [SITEBOARD_STAFF_ROLE],
  ),
];
export const SiteboardApiValidator = {};
for(const item of siteboardApiList) {
  SiteboardApiValidator[item.getType()] = item;
}
